import React from 'react';
import { useParams, NavLink } from 'react-router-dom';
import Base from './Base';
import DocumentComment from './DocumentComment';
class Document extends Base {
  constructor(props) {
    super(props);
    this.state.showClaim = false;
    this.state.template = props.template;
    this.showHowToCition = 0;
    this.state.showTOC = false;
    this.state.showReference = false;
  }
  componentDidUpdate() {
    this.getData(false);
  }
  componentDidMount() {
    if (this.state.dataHolder !== null) {
      this.state.paperId = this.props.params.paperId;
      return;
    }
    this.getData();
  }
  getData(firstLoad = true) {
    var paperId = this.props.params.paperId;
    if (this.state.paperId === paperId) return;
    this.state.paperId = paperId;
    var url = '';
    if (this.state.template === 1) url = '/doc/' + paperId + "/";
    if (this.state.template === 2) url = '/isi/' + paperId + "/";
    if (!firstLoad) this.lockScreen();
    this.httpPost(url)
    .then((dataHolder) => {
      if (!firstLoad) this.unLockScreen();
      if (this.state.template === 1) this.state.showReference = (dataHolder.refrences.length<6);
      this.setState({dataHolder});
    })
    .catch((error) => {
      if (!firstLoad) this.unLockScreen();
      this.showErrorToast(this.MC(1));
      this.setState({ dataHolder: { status: 0 } });
    });
  }
  getPaperTitle(){
    var title = this.state.dataHolder.record.title;
    if (this.state.template === 2) title = this.state.dataHolder.record.Title;
    
    if (this.state.dataHolder.lang === "en" && !this.isBlank(this.state.dataHolder.record.title_en)) 
      title = this.state.dataHolder.record.title_en;

    if (this.state.dataHolder.record.language == 2 || this.state.template === 2) title = this.toEnglishNumber(title);

    return title;
  }
  getPaperAbstract(){
    var abstract = this.state.dataHolder.record.abstract;

    if (this.state.dataHolder.lang === "en" && !this.isBlank(this.state.dataHolder.record.abstract_en)) 
      abstract = this.state.dataHolder.record.abstract_en;

    if (this.state.dataHolder.record.language == 2 || this.state.template === 2) abstract = this.toEnglishNumber(abstract);

    return abstract;
  }
  getPaperKeywords(){
    var keywords = this.state.dataHolder.record.keywords;

    if (this.state.dataHolder.lang === "en" && !this.isBlank(this.state.dataHolder.record.keywords_en)) 
      keywords = this.state.dataHolder.record.keywords_en;

    if (this.state.dataHolder.record.language == 2) keywords = this.toEnglishNumber(keywords);

    return keywords;
  }
  checkPersonToDocAssign(e){
    this.lockScreen();
    this.httpPost("/ajax/check_person_assign_doc/",{id:this.state.dataHolder.record.id})
    .then(resualt=>{
      this.unLockScreen();
      if (resualt.status === 0){
        this.showErrorToast(resualt.message);
        return;
      }
      if (resualt.status === 1){
        this.showSuccessToast("این مقاله با موفقیت به رزومه شما افزوده شد.")
        this.setState({redirectTo: "/p/" + this.getRealPersonId(this.state.dataHolder.currentPerson) + "/edit/"});
        return;
      }
      if (resualt.status === 2){
        this.showErrorToast(resualt.message);
        this.setState({redirectTo: "/p/" + this.getRealPersonId(this.state.dataHolder.currentPerson) + "/edit/"});
        return;
      }      
    });
  }
  renderGoogleCarousel(){
    var DHL = this.state.dataHolder;
    var s = `{
        "@context":"https://schema.org",
        "@type":"ItemList",
        "itemListElement":[`;

        var position = 1 ;
        for(var i=0;i<DHL.record.Authors.length;i++)
        {
            var url = '';

            var _au = DHL.record.Authors[i];
            if (!this.isNull(_au.Person))
            {                    
                if (_au.Person.display == 1)
                    url = "https://civilica.com/p/" + this.getRealPersonId(_au.Person) + "/";

                if (url != ''){
                    if (position >1) s+= ',';
                    s += `{
                        "@type":"ListItem",
                        "position":` + position + `,
                        "url":"` + url + `"
                    }`;

                    position++ ;
                }
            }
        }
    s += `]}`;
    return s;
  }
  getStatRate(rate){
    let rateCount = 0;
    if (!this.isEmpty(this.state.dataHolder.comments_rating)){
        this.state.dataHolder.comments_rating.forEach(c=>{
            if (c.score === rate) rateCount += c.count;
        })
    }
    return rateCount;
  }
  calcRatingCount(){
    var s1 = this.getStatRate(1);
    var s2 = this.getStatRate(2);
    var s3 = this.getStatRate(3);
    var s4 = this.getStatRate(4);
    var s5 = this.getStatRate(5);
    return s1+s2+s3+s4+s5;
  }
  calcAvgRating(){
    var s1 = this.getStatRate(1);
    var s2 = this.getStatRate(2);
    var s3 = this.getStatRate(3);
    var s4 = this.getStatRate(4);
    var s5 = this.getStatRate(5);

    if (this.isBlank(s1)) s1=0;
    if (this.isBlank(s2)) s2=0;
    if (this.isBlank(s3)) s3=0;
    if (this.isBlank(s4)) s4=0;
    if (this.isBlank(s5)) s5=0;

    return (((s1*1) + (s2*2)  + (s3*3)  + (s4*4)  + (s5*5) ) / this.calcRatingCount()).toFixed(2);
  }
  commentWithTextCount(){
    if (this.isEmpty(this.state.dataHolder.comments)) return 0;
    var c = 0;
    this.state.dataHolder.comments.forEach(_comment=>{
      if (!this.isBlank(_comment.text) && _comment.status == 1) c++;
    });
    return c;
  }
  renderRatingBox(){
    if (this.isEmpty(this.state.dataHolder.comments)) return null;

    if (this.calcAvgRating() <= 0) return null;

    var html = [];
    html.push(<div className={'bg-white dark:bg-light-600 shadow-me border rounded overflow-hidden p-4'}>
              <p className={'font-bold h_title mb-2 border-b pb-2 mb-2 border-b pb-2'}>نظرات خوانندگان</p>
              <div>
                <div className="rating-box" id="DIV_1">
                  <div className="score-container" id="DIV_2">
                      <div className="score" id="DIV_5">
                          {this.calcAvgRating()}
                      </div>
                      <div className="score-container-star-rating" id="DIV_6">
                          <div className="small-star star-rating-non-editable-container" id="DIV_7">
                              <div className="current-rating" id="DIV_8" style={{"width":(this.calcAvgRating()*24) + "px"}}>
                              </div>
                          </div>
                      </div>
                      <div className="reviews-stats" id="DIV_9">
                          <span className="reviewers-small" id="SPAN_10"></span> <span className="reviews-num" id="SPAN_11">{this.money(this.state.dataHolder.comments.length)}</span> تعداد پژوهشگران نظر دهنده
                      </div>
                  </div>
                  <div className="rating-histogram" id="DIV_12">
                      <div className="rating-bar-container five" id="DIV_13">
                          <span className="bar-label" id="SPAN_14"><span className="star-tiny star-full" id="SPAN_15"></span>5</span><span id="SPAN_16" style={{"width":Math.ceil((this.getStatRate(5)/this.state.dataHolder.comments.length)*100)+"%"}}></span> <span className="bar-number" id="SPAN_17">{this.getStatRate(5)}</span>
                      </div>
                      <div className="rating-bar-container four" id="DIV_18">
                          <span className="bar-label" id="SPAN_19"><span className="star-tiny star-full" id="SPAN_20"></span>4</span><span id="SPAN_21" style={{"width":Math.ceil((this.getStatRate(4)/this.state.dataHolder.comments.length)*100)+"%"}}></span> <span className="bar-number" id="SPAN_22">{this.getStatRate(4)}</span>
                      </div>
                      <div className="rating-bar-container three" id="DIV_23">
                          <span className="bar-label" id="SPAN_24"><span className="star-tiny star-full" id="SPAN_25"></span>3</span><span id="SPAN_26" style={{"width":Math.ceil((this.getStatRate(3)/this.state.dataHolder.comments.length)*100)+"%"}}></span> <span className="bar-number" id="SPAN_27">{this.getStatRate(3)}</span>
                      </div>
                      <div className="rating-bar-container two" id="DIV_28">
                          <span className="bar-label" id="SPAN_29"><span className="star-tiny star-full" id="SPAN_30"></span>2</span><span id="SPAN_31" style={{"width":Math.ceil((this.getStatRate(2)/this.state.dataHolder.comments.length)*100)+"%"}}></span> <span className="bar-number" id="SPAN_32">{this.getStatRate(2)}</span>
                      </div>
                      <div className="rating-bar-container one" id="DIV_33">
                          <span className="bar-label" id="SPAN_34"><span className="star-tiny star-full" id="SPAN_35"></span>1</span><span id="SPAN_36" style={{"width":Math.ceil((this.getStatRate(1)/this.state.dataHolder.comments.length)*100)+"%"}}></span> <span className="bar-number" id="SPAN_37">{this.getStatRate(1)}</span>
                      </div>
                  </div>
                </div>
              </div>
            </div>);
    if (this.commentWithTextCount()>0){
      html.push(<div className={'bg-white dark:bg-light-600 shadow-me border rounded overflow-hidden p-4'}>
                  <p className={'font-bold h_title mb-2 border-b pb-2 mb-2 border-b pb-2'}>نقد پژوهشگران</p>
                  <ul>
                    {this.state.dataHolder.comments.map(_comment=>
                      (!this.isBlank(_comment.text) && _comment.status == 1) ?
                        <li>
                          {!this.isNull(_comment.RealPerson) ?
                            <b>{_comment.RealPerson.fname + ' ' + _comment.RealPerson.lname} ({this.g2j(_comment.date,3)}): </b>
                          :
                            <b>{_comment.writer_name} ({this.g2j(_comment.date,3)}): </b>
                          }
                          {_comment.text}
                        </li>
                      :null
                    )}
                  </ul>
                </div>);
    }

    return html;
  }
  validThorCountToCarsole(){
    if (this.state.dataHolder.record.Authors.length <=0 ) return 0;
    var position = 0 ;
    for(var i=0;i<this.state.dataHolder.record.Authors.length;i++)
    {
        var _au = this.state.dataHolder.record.Authors[i];
        if (!this.isNull(_au.Person))
        {
            if (_au.Person.display == 1)
                position++ ;
        }
    }
    return position;
  }
  getAuthorsSchema(){
    var str = ''
    this.state.dataHolder.record.Authors.sort((a,b)=>a.order-b.order).forEach((_au,_au_index)=>
        {
            str += `{
                "@type": "Person",
                "name": "` + _au.fname +" " + _au.lname + `",
                "url":"`;
                if (_au.Person !== null )
                {
                    if (_au.Person.display == 1)
                        str += "https://civilica.com/p/" + this.getRealPersonId(_au.Person) + "/";
                    else
                        str += "https://civilica.com/search/paper/n-" + encodeURI(this.pureStringToGoogle(_au.fname + "_" + _au.lname)) + "/";
                }
                else
                    str += "https://civilica.com/search/paper/n-" +  encodeURI(this.pureStringToGoogle(_au.fname + "_" + _au.lname)) + "/";
            str += `",
                "affiliation": "` + this.pureStringToGoogle(_au.aff) + `"
            }` + (this.state.dataHolder.record.Authors.length-1>_au_index ? `,` : "")
        }
    );
    return str;
  }
  renderGoogleStructorsData(){
    var resualt = []; 
    var commentCount = 0;
    if (!this.isEmpty(this.state.dataHolder.comments)){
      commentCount = this.state.dataHolder.comments.length;
    }
    if (this.state.dataHolder.record.document_type == 3)
    {
        resualt.push(
            <script type="application/ld+json" dangerouslySetInnerHTML={{
                __html: `{
                    "@context": "https://schema.org",
                    "@type": "Article",
                    "name": "` + this.pureStringToGoogle(this.getPaperTitle()) + `",
                    "headline": "` + this.pureStringToGoogle(this.state.dataHolder.record.topic) + `",
                    "articleSection": "",
                    "articleBody": "` + this.pureStringToGoogle(this.htmlToString(this.getPaperAbstract())) + `",
                    "keywords": "",
                    "publisher": {
                    "@type": "Organization",
                    "name": "CIVILICA",
                    "logo": {
                        "@type": "ImageObject",
                        "url": "https://civilica.com/images/logo.gif"
                    }
                    },
                    "image": "` + this.toImageUrl(this.state.dataHolder.record,"report") + `",
                    "inLanguage": {
                    "@type": "Language",
                    "name": "Persian",
                    "alternateName": "fa-IR"
                    },
                    "author": [` +
                        this.getAuthorsSchema()
                    + `],
                    "commentCount": "` + commentCount + `",
                    "url" : "https://civilica.com/doc/` + this.state.dataHolder.record.id + `/",
                    "description" : "` + this.pureStringToGoogle(this.htmlToString(this.getPaperAbstract()).substr(0,155)) + ` ...",
                    "datePublished" : ""
            }`}} />);
    }
    if (this.state.dataHolder.record.document_type == 1)
    {
        if (this.validThorCountToCarsole() > 0 )
            resualt.push(<script type="application/ld+json" dangerouslySetInnerHTML={{__html: this.renderGoogleCarousel()}} />);
           
        resualt.push(<script type='application/ld+json' dangerouslySetInnerHTML={{
                __html: `{
                    "@context": "https://schema.org",
                    "@type": "Article",
                    "name": "` + this.pureStringToGoogle(this.getPaperTitle()) + `",
                    "headline": "` + this.pureStringToGoogle(this.state.dataHolder.record.title) + `",
                    "articleSection": "` + this.pureStringToGoogle(this.state.dataHolder.record.topic) + `",
                    "articleBody": "` + this.pureStringToGoogle(this.htmlToString(this.getPaperAbstract())) + `",
                    "keywords": "` + (this.isBlank(this.getPaperKeywords()) ? "" : this.pureStringToGoogle(this.getPaperKeywords())) + `",
                    "publisher": {
                        "@type": "Organization",
                        "name": "CIVILICA",
                        "logo": {
                            "@type": "ImageObject",
                            "url": "https://civilica.com/images/logo.gif"
                        }
                    },
                    "image": "https://civilica.com/` + this.toImageUrl(this.state.dataHolder.record,"paper",true) + `",
                    "inLanguage": {
                        "@type": "Language",
                        "name": "Persian",
                        "alternateName": "fa-IR"
                    },
                    "author": [` +
                        this.getAuthorsSchema()
                    + `],
                    "commentCount": "` + this.pureStringToGoogle(commentCount) + `",
                    "url": "https://civilica.com/doc/` + this.state.dataHolder.record.id + `/",
                    "description": "` + this.pureStringToGoogle(this.htmlToString(this.getPaperAbstract()).substr(0,155)) + ` ...",
                    "datePublished": "` + this.state.dataHolder.record.add_date + `",
                    "dateModified": "` + this.state.dataHolder.record.edit_date + `"                            
                }`}}/>  );

        if (commentCount > 0 && this.calcAvgRating() > 0 )
            resualt.push(<script type='application/ld+json' dangerouslySetInnerHTML={{
                __html: `{
                        "@context": "https://schema.org",
                        "@type": "CreativeWorkSeason",
                        "name": "` + this.pureStringToGoogle(this.getPaperTitle()) + `",
                        "aggregateRating": {
                            "@type": "AggregateRating",
                            "ratingCount": "` + this.calcRatingCount()+ `",
                            "ratingValue": "` + this.calcAvgRating() + `",
                            "bestRating": "5",
                            "worstRating": "1"
                        }
            }`}} />);
    }
    if (this.state.dataHolder.record.document_type == 4)
    {
        if (this.validThorCountToCarsole() > 0 )
            resualt.push(<script type="application/ld+json" dangerouslySetInnerHTML={{__html: this.renderGoogleCarousel()}} />);
           
        resualt.push(<script type='application/ld+json' dangerouslySetInnerHTML={{
                __html: `{
                    "@context": "https://schema.org",
                    "@type": "Article",
                    "name": "` + this.pureStringToGoogle(this.getPaperTitle()) + `",
                    "headline": "` + this.pureStringToGoogle(this.getPaperTitle()) + `",
                    "articleSection": "` + this.pureStringToGoogle(this.state.dataHolder.record.topic) + `",
                    "articleBody": "` + this.pureStringToGoogle(this.htmlToString(this.getPaperAbstract())) + `",
                    "keywords": "` + (this.isBlank(this.getPaperKeywords()) ? "" : this.pureStringToGoogle(this.getPaperKeywords())) + `",
                    "publisher": {
                        "@type": "Organization",
                        "name": "CIVILICA",
                        "logo": {
                            "@type": "ImageObject",
                            "url": "https://civilica.com/images/logo.gif"
                        }
                    },
                    "image": "https://civilica.com/` + this.toImageUrl(this.state.dataHolder.record,"paper",true) + `",
                    "inLanguage": {
                        "@type": "Language",
                        "name": "Persian",
                        "alternateName": "fa-IR"
                    },
                    "author": [` +
                        this.getAuthorsSchema()
                    + `],
                    "commentCount": "` + this.pureStringToGoogle(commentCount) + `",
                    "url": "https://civilica.com/doc/` + this.state.dataHolder.record.id + `/",
                    "description": "` + this.pureStringToGoogle(this.htmlToString(this.getPaperAbstract()).substr(0,155)) + ` ...",
                    "datePublished": "` + this.state.dataHolder.record.add_date + `",
                    "dateModified": "` + this.state.dataHolder.record.edit_date + `"                            
                }`}}/>  );

        if (commentCount > 0 && this.calcAvgRating() > 0 )
            resualt.push(<script type='application/ld+json' dangerouslySetInnerHTML={{
                __html: `{
                        "@context": "https://schema.org",
                        "@type": "CreativeWorkSeason",
                        "name": "` + this.pureStringToGoogle(this.getPaperTitle()) + `",
                        "aggregateRating": {
                            "@type": "AggregateRating",
                            "ratingCount": "` + this.calcRatingCount()+ `",
                            "ratingValue": "` + this.calcAvgRating() + `",
                            "bestRating": "5",
                            "worstRating": "1"
                        }
            }`}} />);
    }
    return resualt;
  }
  getCaptions() {
    if (this.state == null) return '';
    if (this.state.dataHolder.record.document_type === 1) return (this.state.dataHolder.lang === "en" ? "Papers" : 'مقالات');
    if (this.state.dataHolder.record.document_type === 3) {
      if (this.state.dataHolder.record.document_sub_type === 3) return (this.state.dataHolder.lang === "en" ? "Books" : 'کتابهای');
      if (this.state.dataHolder.record.document_sub_type === 4) return (this.state.dataHolder.lang === "en" ? "Researches" : 'طرح های پژوهشی');
      if (this.state.dataHolder.record.document_sub_type === 5) return (this.state.dataHolder.lang === "en" ? "Documents" : 'اسناد پژوهشی');
      if (this.state.dataHolder.record.document_sub_type === 6) return (this.state.dataHolder.lang === "en" ? "Report" : 'گزارش');
      if (this.state.dataHolder.record.document_sub_type === 8) return (this.state.dataHolder.lang === "en" ? "Thesis" : 'پایان نامه');
      return (this.state.dataHolder.lang === "en" ? "Researches" : 'طرح های');
    }
    if (this.state.dataHolder.record.document_type === 4) {
      if(this.state.dataHolder.record.document_sub_type === 11) return (this.state.dataHolder.lang === "en" ? "Preprints" : 'پایان نامه های کارشناسی ارشد');
      if(this.state.dataHolder.record.document_sub_type === 12) return (this.state.dataHolder.lang === "en" ? "Preprints" : 'پایان نامه های دکترا');
      if(this.state.dataHolder.record.document_sub_type === 13) return (this.state.dataHolder.lang === "en" ? "Preprints" : 'سمینار های دوره کارشناسی');
      if(this.state.dataHolder.record.document_sub_type === 14) return (this.state.dataHolder.lang === "en" ? "Preprints" : 'سمینار های کارشناسی ارشد');
      if(this.state.dataHolder.record.document_sub_type === 15) return (this.state.dataHolder.lang === "en" ? "Preprints" : 'پروپوزال های پایان نامه کارشناسی ارشد');
      if(this.state.dataHolder.record.document_sub_type === 16) return (this.state.dataHolder.lang === "en" ? "Preprints" : 'پروپوزال های پایان نامه دکترا');
      return (this.state.dataHolder.lang === "en" ? "Preprints" : 'اسناد پیش چاپ');
    }
    return '';
  }
  getCaption() {
    if (this.state.dataHolder == null) return '';
    if (this.state.dataHolder.record.document_type === 1) return (this.state.dataHolder.lang === "en" ? "Paper" : 'مقاله');
    if (this.state.dataHolder.record.document_type === 3) {
      if (this.state.dataHolder.record.document_sub_type === 3) return (this.state.dataHolder.lang === "en" ? "Book" : 'کتاب');
      if (this.state.dataHolder.record.document_sub_type === 4) return (this.state.dataHolder.lang === "en" ? "Research" : 'طرح پژوهشی');
      if (this.state.dataHolder.record.document_sub_type === 5) return (this.state.dataHolder.lang === "en" ? "Document" : 'سند پژوهشی');
      if (this.state.dataHolder.record.document_sub_type === 6) return (this.state.dataHolder.lang === "en" ? "Report" : 'گزارش');
      if (this.state.dataHolder.record.document_sub_type === 8) return (this.state.dataHolder.lang === "en" ? "Thesis" : 'پایان نامه');
      return (this.state.dataHolder.lang === "en" ? "Research" : 'طرح پژوهشی');
    }
    if (this.state.dataHolder.record.document_type === 4) {
      if(this.state.dataHolder.record.document_sub_type === 11) return (this.state.dataHolder.lang === "en" ? "Preprint" : 'پایان نامه کارشناسی ارشد');
      if(this.state.dataHolder.record.document_sub_type === 12) return (this.state.dataHolder.lang === "en" ? "Preprint" : 'پایان نامه دکترا');
      if(this.state.dataHolder.record.document_sub_type === 13) return (this.state.dataHolder.lang === "en" ? "Preprint" : 'سمینار دوره کارشناسی');
      if(this.state.dataHolder.record.document_sub_type === 14) return (this.state.dataHolder.lang === "en" ? "Preprint" : 'سمینار کارشناسی ارشد');
      if(this.state.dataHolder.record.document_sub_type === 15) return (this.state.dataHolder.lang === "en" ? "Preprint" : 'پروپوزال پایان نامه کارشناسی ارشد');
      if(this.state.dataHolder.record.document_sub_type === 16) return (this.state.dataHolder.lang === "en" ? "Preprint" : 'پروپوزال پایان نامه دکترا');

      return (this.state.dataHolder.lang === "en" ? "Preprint" : 'پیش چاپ');
    }
    return '';
  }
  citationString() {
    let paper = this.state.dataHolder.record;
    let Content = '';
    Content = '';
    let index = 0;
    let comma = ',';
    if (this.state.dataHolder.record.language === 1 || this.state.dataHolder.record.language === 3) comma = '،';

    paper.Authors.forEach((_au) => {
      if (index > 0) {
        if (this.state.dataHolder.record.language === 1 || this.state.dataHolder.record.language === 3) Content += ' و ';
        else Content += ' and ';
      }
      index++;
      Content += _au.lname + comma + ' ' + _au.fname;
    });

    if (paper.document_sub_type === 1 && paper.legal_person_id !== null) {
      let confName = this.T(paper.LegalPerson, 'legal_person_name');
      let cityName = this.T(paper.LegalPerson.City, 'city_name');

      if (this.state.dataHolder.record.language !== 1 && this.state.dataHolder.record.language !== 3) {
        if (!this.isNull(paper.LegalPerson)) {
          confName = paper.LegalPerson.name_en;
          if (this.isBlank(confName)) confName = paper.LegalPerson.name;

          if (!this.isNull(paper.LegalPerson.City)) {
            cityName = paper.LegalPerson.City.latinCityName;
            if (this.isBlank(cityName)) cityName = paper.LegalPerson.City.persianCityName;
          }
        }
      }

      let _lg = '';
      if (!this.isNull(paper.LegalPerson)) _lg = comma + confName + (paper.LegalPerson.City !== null ? comma + cityName : '');

      Content +=
        comma +
        paper.year +
        comma +
        this.getPaperTitle() +
        _lg +
        (this.isBlank(this.getField('Holder')) ? '' : comma + this.getField('Holder')) +
        (this.isBlank(this.getField('Faculty')) ? '' : comma + this.getField('Faculty')) +
        comma +
        'https://civilica.com/doc/' +
        paper.id;
    }
    if (paper.document_sub_type === 2 && paper.legal_person_id !== null) {
      Content += comma + paper.year + comma + this.getPaperTitle() + comma + 'https://civilica.com/doc/' + paper.id;
    }
    if (paper.document_type === 4) {
      Content += comma + paper.year + comma + this.getPaperTitle() + comma + 'https://civilica.com/doc/' + paper.id;
    }
    return Content;
  }
  getField(field) {
    if (this.isNull(this.state.dataHolder.record.LegalPerson)) return '';
    let f = '';
    this.state.dataHolder.record.LegalPerson.Fields.forEach((_field) => {
      if (field === _field.field) f = _field.value;
    });
    return f === undefined ? '' : f;
  }
  renderHowToRefrence() {
    if (this.state.dataHolder.record.document_type !== 1 && this.state.dataHolder.record.document_type !== 4) return null;
    
    return <div className="p-4 bg-white shadow-me border rounded dark:bg-light-600 mb-4">
              <p className="font-bold h_title mb-2 border-b pb-2">{this.state.dataHolder.lang === 'fa' ? "نحوه استناد به " + this.getCaption() : "How to cite"}:</p>
              {this.state.dataHolder.lang === 'fa' ? 'در صورتی که می خواهید در اثر پژوهشی خود به این ' + this.getCaption() + ' ارجاع دهید، به سادگی می توانید از عبارت زیر در بخش منابع و مراجع استفاده نمایید:' 
              :
                "If you want to refer to this " + this.getCaption() + " in your research work, you can simply use the following phrase in the references section:"
              }
              <br />
              <div dir={this.state.dataHolder.record.language === 2 || this.state.dataHolder.record.language === 4 ? 'ltr' : 'rtl'}>{this.citationString()}</div>
              <br />
              {[
                    'در داخل متن نیز هر جا که به عبارت و یا دستاوردی از این ' + this.getCaption() + ' اشاره شود پس از ذکر مطلب، در داخل پارانتز، مشخصات زیر نوشته می شود.',
                    <br />,
                    'برای بار اول: (',
                    <span dir={this.state.dataHolder.record.language === 1 || this.state.dataHolder.record.language === 3 ? 'rtl' : 'ltr'}>
                      {this.state.dataHolder.record.Authors.sort((a, b) => a.order - b.order).map((_au, index) =>
                        index === 0
                          ? this.state.dataHolder.record.language === 2 || this.state.dataHolder.record.language === 4
                            ? this.state.dataHolder.record.year + ', ' + _au.lname + ', ' + _au.fname + '؛ '
                            : this.state.dataHolder.record.year + '، ' + _au.lname + '، ' + _au.fname + '؛ '
                          : index === 1
                          ? _au.fname + ' ' + _au.lname
                          : this.state.dataHolder.record.language === 2 || this.state.dataHolder.record.language === 4
                          ? ' and ' + _au.fname + ' ' + _au.lname
                          : ' و ' + _au.fname + ' ' + _au.lname
                      )}
                    </span>,
                    ')',
                    <br />,
                    'برای بار دوم به بعد: (',
                    <span dir={this.state.dataHolder.record.language === 1 || this.state.dataHolder.record.language === 3 ? 'rtl' : 'ltr'}>
                      {this.state.dataHolder.record.Authors.sort((a, b) => a.order - b.order).map((_au, index) =>
                        index === 0
                          ? this.state.dataHolder.record.language === 2 || this.state.dataHolder.record.language === 4
                            ? this.state.dataHolder.record.year + ', ' + _au.lname + '؛ '
                            : this.state.dataHolder.record.year + '، ' + _au.lname + '؛ '
                          : index === 1
                          ? _au.lname
                          : this.state.dataHolder.record.language === 2 || this.state.dataHolder.record.language === 4
                          ? ' and ' + _au.lname
                          : ' و ' + _au.lname
                      )}
                    </span>,
                    ')',
                    <br />,
                    `برای آشنایی کامل با نحوه مرجع نویسی لطفا بخش `,
                    <a href="https://help.civilica.com/%D9%BE%DA%98%D9%88%D9%87%D8%B4%DA%AF%D8%B1%D8%A7%D9%86:%D8%A7%D8%B1%D8%AC%D8%A7%D8%B9_%D8%A8%D9%87_%D9%85%D9%82%D8%A7%D9%84%D8%A7%D8%AA_%D8%B3%DB%8C%D9%88%DB%8C%D9%84%DB%8C%DA%A9%D8%A7">
                      راهنمای سیویلیکا (مرجع دهی)
                    </a>,
                    ` را ملاحظه نمایید.`,
                  ]}
          </div>
  }
  renderReviews() {
    if (this.state.dataHolder.record.document_type !== 4) return null;
    if (this.isEmpty(this.state.dataHolder.reviews)) return null;
    
    return <div className="p-4 bg-white shadow-me border rounded dark:bg-light-600 mb-4">
              <p className="font-bold h_title mb-2 border-b pb-2">تاریخچه ویرایشهای پیش چاپ توسط نویسنده</p>
              {this.state.dataHolder.reviews.map(review=>
                <p>{review.action === 4 && <b>نمایه سازی</b>}{review.action === 8 && <b>ویرایش</b>} {this.g2j(review.date)} </p>
              )}
          </div>
  }
  renderRefrence(ref) {
    let confCaption = 'مقاله کنفرانسی';
    let jornalCaption = 'مقاله ژورنالی';
    if (this.state.lang !== 'fa') {
      confCaption = 'Conference Paper';
      jornalCaption = 'Journal Paper';
    }
    let languageClass = '';
    if (ref.ref_language === 2 || ref.ref_language === 4) languageClass = 'text-left';

    let points = null;
    if (this.state.dataHolder.currentManager !== null) points = ['(', ref.id, ')', '.  ', '(', ref.ref_probability, '). '];

    let c = null;
    if (!this.isNull(ref.RefDocument)) {
      c = [
        <NavLink to={'/doc/' + ref.RefDocument.id + '/'} title={ref.RefDocument.title} className="font-bold">{ref.RefDocument.title}</NavLink>,
      ];
      if (ref.RefLegalPerson !== null){
        c.push(
          <NavLink to={this.getLegalLink(ref.RefLegalPerson)} title={this.T(ref.RefLegalPerson,'legal_person_name')}>            
            {ref.RefLegalPerson.role_id === 6 && <span> [{confCaption}]</span>}
            {ref.RefLegalPerson.role_id === 7 && <span> [{jornalCaption}]</span>}
          </NavLink>
        );
      }
    } else {
      if (this.state.dataHolder.currentManager !== null) c = [ref.raw_data];
      else {
        let minRaw = '';
        let words = ref.raw_data.split(' ');
        for (var i = 0; i < Math.min(10, words.length); i++) minRaw += words[i] + ' ';
        c = [minRaw + ' ...'];
      }
      if (ref.RefLegalPerson !== null)
        c.push(
          <NavLink to={this.getLegalLink(ref.RefLegalPerson)} title={this.T(ref.RefLegalPerson,'legal_person_name')}>
            {ref.RefLegalPerson.role_id === 6 && <span> [{confCaption}]</span>}
            {ref.RefLegalPerson.role_id === 7 && <span> [{jornalCaption}]</span>}
          </NavLink>
        );
    }

    return (
      <div className={languageClass + ' py-3 hover:bg-gray-50 dark:hover:bg-light-600 '}>
        {points}
        {c}
      </div>
    );
  }
  renderRefrences() {
    return <div>
              <p className="font-bold h_title mb-2 border-b pb-2 mb-2 border-b pb-2">
                {this.getEditLink(this.state.dataHolder.record, 'paper_refrences')} مراجع و منابع این {this.getCaption()}:
              </p>
              {this.state.dataHolder.record.document_type !== 4 && <div className="bg-indigo-100 dark:bg-light-700 text-indigo-600 rounded p-3 mb-4">
                لیست زیر مراجع و منابع استفاده شده در این {this.getCaption()} را نمایش می دهد. این مراجع به صورت کاملا ماشینی و بر اساس هوش مصنوعی استخراج شده اند و لذا ممکن است دارای اشکالاتی باشند که به
                مرور زمان دقت استخراج این محتوا افزایش می یابد. مراجعی که مقالات مربوط به آنها در سیویلیکا نمایه شده و پیدا شده اند، به خود {this.getCaption()} لینک شده اند :
              </div>}
              {this.state.dataHolder.record.document_type === 4 && <div className="bg-indigo-100 dark:bg-light-700 text-indigo-600 rounded p-3 mb-4">
              لیست زیر مراجع و منابع استفاده شده در این مقاله پیش چاپ را نمایش می دهد. برخی از مراجع این مقاله ممکن است قبلا در سیویلیکا نمایه شده باشند، در این صورت مراجع مورد نظر به صورت کاملا ماشینی و بر اساس هوش مصنوعی و بدون دخالت انسانی استخراج شده و به مقاله یا منبع مذکور لینک میشوند
              </div>}
              <div className={"flex flex-col divide-y dark:divide-light-700 " + (this.state.showReference ? "" : "hiddenLarge")}>
                {this.state.dataHolder.refrences.map((_ref) => (_ref.ref_language === 1 || _ref.ref_language === 3 ? this.renderRefrence(_ref) : null))}
                {this.state.dataHolder.refrences.map((_ref) => (_ref.ref_language === 2 || _ref.ref_language === 4 ? this.renderRefrence(_ref) : null))}
                <span className='showLarge' onClick={e=> this.setState({showReference:true})}>نمایش کامل مراجع</span>
              </div>
            </div>
  }
  renderAbstract() {
    if (this.state.template === 2){
      if (this.isBlank(this.getPaperAbstract())) return null;
      return  <div className="p-4 bg-white shadow-me border rounded dark:bg-light-600 mb-4">
                <p className="font-bold h_title mb-2 border-b pb-2">چکیده: </p>
                <div className="prose max-w-none my-6 text-color-black text-justify ltr">
                  <div dangerouslySetInnerHTML={{ __html: this.getPaperAbstract() }}></div>
                </div>
              </div>
    }
    if (this.state.template === 1){
      var abstract = this.getPaperAbstract();

      if (this.isBlank(abstract)) return null;

      if (!this.isBlank(this.getPaperKeywords())) {
        var tags = [];
        this.getPaperKeywords()
          .replace(/،/g, ',')
          .replace(/;/g, ',')
          .replace(/؛/g, ',')
          .replace(/–/g, ',')
          .replace(/"/g, ' ')
          .replace(/'/g, ' ')
          .split(',')
          .forEach((v) => {
            tags.push({
              phrase: v,
              count: v.split(" ").length
            });
          });

          tags.sort((a,b)=>a.count-b.count).forEach(f=>{
            var v = f.phrase.trim();
            var link = ' <a style="color:#1e5aa0" title="' + v + '" href="https://civilica.com/search/paper/k-' + encodeURI(v) + '/">' + v + '</a> ';
            var phrase = ' ' + v + ' ';
            while (abstract.includes(phrase) && v.trim().split(' ').length <= 3) {
              abstract = abstract.replace(phrase, link);
            }
          });
      }

      return  <div className="p-4 bg-white shadow-me border rounded dark:bg-light-600 mb-4">
                <p className="font-bold h_title mb-2 border-b pb-2">{this.state.dataHolder.lang === "en" ? 
                  (this.state.dataHolder.record.language == 2 ? this.toEnglishNumber(this.getPaperTitle()) : this.getPaperTitle()) + " abstract" 
                  : 
                  "چکیده " + this.getCaption() + " " + this.getPaperTitle()
                }</p>
                <div className={"prose max-w-none my-6 text-color-black text-justify" + (this.state.dataHolder.record.language == 2 ? " ltr " : "")}>
                  <div dangerouslySetInnerHTML={{ __html: abstract }}></div>
                </div>
              </div>
    }
  }
  hasMedia(format) {
    let f = false;
    this.state.dataHolder.medias.forEach((m) => {
      if (m.format === format) f = true;
    });
    return f;
  }
  renderAuthors() {
    var resualt = [];

    resualt.push(<p className="font-bold h_title mb-2 border-b pb-2">
      {this.state.dataHolder.lang === "en" ? 
      (this.state.dataHolder.record.language == 2 ? this.toEnglishNumber(this.getPaperTitle()) : this.getPaperTitle())+ " authors" : 
      "نویسندگان " + this.getCaption() + " " + this.getPaperTitle()
      }
      </p>);

    var html = [];
    this.state.dataHolder.record.Authors.sort((a, b) => a.order - b.order).map((_au) => {
      var authorName = _au.fname + ' ' + _au.lname;
      if (this.state.dataHolder.record.language === 2 && !this.isBlank(_au.fname_en)){
        authorName = _au.fname_en + ' ' + _au.lname_en;
      }

      var _html = [];
      var authorPageLink = '';
      var authorPageTitle = authorName;
      if (!this.isNull(_au.Person)) {
        if (_au.Person.display === 1) authorPageLink = '/p/' + this.getRealPersonId(_au.Person) + '/';
        else {
          authorPageLink = '/search/paper/n-' + encodeURI((authorName).replace(/\s/g, '_')) + '/';
        }
      } 
      else {
        authorPageLink = '/search/paper/n-' + encodeURI((authorName).replace(/\s/g, '_')) + '/';

        if (this.state.dataHolder.record.document_type === 1) {
          authorPageTitle =
            'جستجوی ' +
            this.getCaptions() +
            ' نوشته شده توسط ' +
            authorName +
            '. توجه نمایید که جستجو بر اساس نام و نام خانوادگی صورت می پذیرد و ممکن است به دلیل تشابه اسمی همان فرد نباشد.';
        }
        else{
          authorPageTitle =
            'جستجوی اسناد نوشته شده توسط ' + authorName + '. توجه نمایید که جستجو بر اساس نام و نام خانوادگی صورت می پذیرد و ممکن است به دلیل تشابه اسمی همان فرد نباشد.';
        }
      }

      var blue_tick = null;

      if (!this.isNull(_au.Person)){
        if (_au.Person.blue_verify === 1){
          blue_tick = <span className="verified_person_badget"></span>
        }
        _html.push(
          <span>
            {this.getEditLink(_au.Person, 'realperson')}
            <NavLink to={authorPageLink} title={authorPageTitle}>
              <div className="ml-2 rounded-full image48 border animate-pulse lazy" data-src={this.toImageUrl(_au.Person, 'real_person')}></div>
            </NavLink>
          </span>
        );
      }

      if (!this.isNull(_au.Affilation)){
        _html.push(
          <span>
            {_au.Affilation.role_id === 3 || _au.Affilation.role_id === 4 ?
              <a href={this.getLegalLink(_au.Affilation)} title={this.T(_au.Affilation,'legal_person_name')}>
                <div className="ml-2 rounded-full image48 border animate-pulse lazy" data-src={this.toImageUrl(_au.Affilation, 'legal_person')}></div>
              </a>
            :
              this.LinkRenders({
                url: this.getLegalLink(_au.Affilation),
                title: this.T(_au.Affilation,'legal_person_name'),
                content: (
                  <div className="ml-2 rounded-full image48 border animate-pulse lazy" data-src={this.toImageUrl(_au.Affilation, 'legal_person')}></div>
                )
              })
            }
          </span>
        );
      }

      var _html2 = [];
      _html2.push(
        <NavLink className="text-color-base dark:text-color-base-dark hover:text-brand dark:hover:text-yellow-500 btn" to={authorPageLink} title={authorPageTitle}>
          {authorName}{blue_tick}{(this.isBlank(_au.role)?"":" ("+_au.role+")")}
        </NavLink>
      );

      if (!this.isBlank(_au.aff)) _html2.push(<p> {_au.aff}</p>);

      html.push(<div className="my-2 flex flex-row items-center">
        <div className='flex flex-shrink-0 rtl:ml-2 ltr:mr-2 flex-row'>{_html}</div>
        <div className='flex flex-col'>{_html2}</div>
      </div>);
    });

    resualt.push(<div className={this.state.dataHolder.record.language === 2 || this.state.dataHolder.record.language === 4 ? 'ltr' : ''}>{html}</div>);
    return resualt;
  }
  renderVIPMediaBox(){    
    if (this.state.template === 1) {
      if (this.state.dataHolder.free_medias_vip.length <= 0) return null;

      if (this.isNull(this.state.dataHolder.currentPerson)){
        return  <div className="rounded-lg border border-gray-300 dark:border-light-600 mb-4">
                  <div className="bg-gray-300 dark:bg-light-600 p-3 flex items-center">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                      <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
                      />
                      </svg>
                      <p className="font-bold text-lg ">دانلود فایلهای پیوست {this.getCaption()}</p>
                  </div>
                  <div className="p-4 flex flex-col space-y-4">
                      <span>جهت دانلود فایل های پیوست این {this.getCaption()} بایستی عضو سیویلیکا شوید. چنانچه عضو سیویلیکا هستید لطفا ابتدا وارد حساب کاربری خود شوید تا بتوانید فایل ها را مشاهده و دانلود نمایید.</span>
                  </div>
                </div>
      }

      return  <div className="rounded-lg border border-gray-300 dark:border-light-600 mb-4">
                <div className="bg-gray-300 dark:bg-light-600 p-3 flex items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
                    />
                    </svg>
                    <p className="font-bold text-lg ">دانلود فایلهای پیوست {this.getCaption()}</p>
                </div>
                <div className="p-4 flex flex-col space-y-4">
                    <span>جهت دانلود فایل های پیوست این {this.getCaption()} بر روی لینک های زیر کلیک نمایید</span>
                    {this.state.dataHolder.free_medias_vip.map(_m => 
                      <div className="flex justify-end">
                        {!this.isBlank(_m.caption) && <p>{_m.caption}</p>}
                        <a className="px-4 py-2 rounded bg-brand hover:bg-brand/90 text-white" href={"/get/media/" + _m.id + "/"}> {_m.caption} (فایل {this.mediaFormatName(_m.format)})</a>
                      </div>
                    )}
                </div>
              </div>
    }

    return null;
  }
  getPageCount(){
      let p = 0;
      if (!this.isBlank(this.state.dataHolder.record.Pages))
      {
          if (this.state.dataHolder.record.Pages.indexOf("-")>=0)
          {
              try{
              p = parseInt(this.state.dataHolder.record.Pages.split("-")[1]) - parseInt(this.state.dataHolder.record.Pages.split("-")[0]);
              }catch(err){
                  p=0;
              }
          }
      }
      return p;        
  }
  renderDocumentDetailItems() {
    var DHL = this.state.dataHolder;
    var resualt = [];

    if (this.state.template === 2){

      resualt.push(
        <div>
          <div className="text-color-base dark:text-color-base-dark flex py-2">
            {DHL.lang === 'fa' ? <span className="font-bold">اعتبار موردنیاز: </span> : <span className="font-bold">Credit: </span>}
            {DHL.record.Credit}
          </div>
          <div className="text-color-base dark:text-color-base-dark flex py-2">
            {DHL.lang === 'fa' ? <span className="font-bold">تعداد صفحات: </span> : <span className="font-bold">Pages: </span>}
            {!this.isBlank(DHL.record.Pages) ?
                DHL.record.Pages.indexOf("-")>=0 ?
                <b> {this.getPageCount()} صفحه ({DHL.record.Pages})</b>
                :
                <b> نامشخص </b>
            :
              <b> نامشخص </b>
            }
          </div>
          <div className="text-color-base dark:text-color-base-dark flex py-2">
            {DHL.lang === 'fa' ? <span className="font-bold">زبان: </span> : <span className="font-bold">زبان: </span>}
            {this.enumString(DHL.record.language,"language")}
          </div>
          {!this.isBlank(DHL.record.Container_Title) &&
            <div className="text-color-base dark:text-color-base-dark flex py-2">
              {DHL.lang === 'fa' ? <span className="font-bold">منتشر شده در: </span> : <span className="font-bold">Container: </span>}
              {DHL.record.Container_Title}
            </div>
          }
          <div className="text-color-base dark:text-color-base-dark flex py-2">
            {DHL.lang === 'fa' ? <span className="font-bold">دوره: </span> : <span className="font-bold">Vol: </span>}
            {DHL.record.Volume}
          </div>
          <div className="text-color-base dark:text-color-base-dark flex py-2">
            {DHL.lang === 'fa' ? <span className="font-bold">شماره:</span> : <span className="font-bold">Issue: </span>}
            {DHL.record.Issue}
          </div>
          <div className="text-color-base dark:text-color-base-dark flex py-2">
            {DHL.lang === 'fa' ? <span className="font-bold">سال انتشار: </span> : <span className="font-bold">Year: </span>}
            {DHL.record.Year}
          </div>
          <div className="text-color-base dark:text-color-base-dark flex py-2">
            {DHL.lang === 'fa' ? <span className="font-bold">نوع این مطلب: </span> : <span className="font-bold">Type: </span>}
            {DHL.record.DocType}
          </div>
          <div className="text-color-base dark:text-color-base-dark flex py-2">
            {DHL.lang === 'fa' ? <span className="font-bold">سازمان ناشر: </span> : <span className="font-bold">Publisher: </span>}
            {DHL.record.Publisher}
          </div>
          <div className="text-color-base dark:text-color-base-dark flex py-2">
            {DHL.lang === 'fa' ? <span className="font-bold">کد DOI مقاله: </span> : <span className="font-bold">DOI: </span>}
            {DHL.record.DOIcode}
          </div>
          {!this.isBlank(DHL.record.DOILink) &&
            <div className="text-color-base dark:text-color-base-dark flex py-2">
              {DHL.lang === 'fa' ? <span className="font-bold">لینک اطلاعات کامل مقاله: </span> : <span className="font-bold">Link: </span>}
              <a href={DHL.record.DOILink} target="_blank" rel="noopener noreferrer">{DHL.record.DOILink}</a>
            </div>
          }
        </div>
      );

      resualt.push(
        <div className="text-color-base dark:text-color-base-dark flex py-2 flex-wrap">
          {DHL.lang === 'fa' ? <span className="font-bold">نویسندگان مقاله: </span> : <span className="font-bold">Authors: </span>}
          {DHL.record.Authors}
        </div>
        );

      resualt.push(<div className='bg-indigo-100 dark:bg-light-700 text-indigo-600 rounded p-3 mb-4'>
                    توجه: قبل از اقدام به دانلود مقالات ISI، حتما از تعداد صفحات و نوع مطلب اطمینان حاصل نمایید. با استفاده از لینک اطلاعات فوق، می توانید به صفحه اطلاعات این مقاله در سایت ناشر مراجعه نمایید و تعداد صفحات و... را به دقت کنترل فرمایید. پس از اطمینان به این صفحه بازگشته و مراحل خرید و دانلود فایل مقاله را انجام دهید.
                    <br />برخی از مقالات رایگان می باشند و بدون خرید از سیویلیکا با کلیک بر روی لینک فوق، از طریق سایت ناشر قابل دانلود می باشند.
                  </div>);

      resualt.push(<div className={'flex flex-col justify-center fixed inset-x-0 bottom-0 bg-white dark:bg-light-600 z-99 lg:relative border-t dark:border-light-700 lg:border-t-0'}>
      <div className="flex  justify-center">
        <a title={DHL.lang === 'fa' ? 'دانلود فایل مقاله' : 'Download paper'} href={'https://civilica.com/isi/' + DHL.record.Paper_ID + '/download/' } className={"bg-brand flex items-center btn hover:bg-brand/90 text-white px-4 py-2 text-center my-2 rounded" + (!this.isNull(DHL.currentIpPerson) ? " mb-8" : "")}>
          {this.getSVGIcon("download","h-6 w-6 rtl:ml-2 ltr:mr-2")}
          دانلود فایل مقاله
        </a>
      </div>
      </div>);

      resualt.push(<div className={'hidden flex flex-col justify-center fixed inset-x-0 bottom-0 bg-white dark:bg-light-600 z-99 lg:relative border-t dark:border-light-700 lg:border-t-0'} id="buy_button">
          <div className="flex  justify-center">
            <a title={DHL.lang === 'fa' ? 'دانلود فایل مقاله' : 'Download paper'} href={'https://civilica.com/isi/' + DHL.record.Paper_ID + '/download/' } className={"bg-brand flex items-center btn hover:bg-brand/90 text-white px-4 py-2 text-center my-2 rounded" + (!this.isNull(DHL.currentIpPerson) ? " mb-8" : "")}>
              {this.getSVGIcon("download","h-6 w-6 rtl:ml-2 ltr:mr-2")}
              دانلود فایل مقاله
            </a>
          </div>
        </div>);

      return <div className="p-4 bg-white shadow-me border rounded dark:bg-light-600 mb-4">
                <header className='col-span-12 lg:col-span-7 xl:col-span-8'>
                  <h1 className="font-bold h_title mb-2 border-b pb-2">{this.getEditLink(DHL.record,"isi")}{this.getPaperTitle()}</h1>
                </header>
                <div className=' flex flex-col md:flex-row'>
                <div className="rtl:mr-2 ltr:ml-2  flex flex-col flex-auto ">
                  {resualt}
                </div>
              </div>
            </div>
    }
    if (this.state.template === 1){
      if (DHL.record.document_sub_type === 3) {
        if (!this.isNull(DHL.record.LegalPerson))
          resualt.push(
            <div className="text-color-base dark:text-color-base-dark flex flex-wrap pt-2">
              {DHL.lang === 'fa' ? <span className="font-bold">ناشر: </span> : <span className="font-bold">Publisher:</span>}
              {DHL.lang === 'fa' ? (
                <NavLink to={'/l/' + DHL.record.legal_person_id + '/'} title={DHL.record.LegalPerson.name}>
                  {DHL.record.LegalPerson.name}
                </NavLink>
              ) : (
                <NavLink to={'/l/' + DHL.record.legal_person_id + '/'} title={DHL.record.LegalPerson.name_en}>
                  {DHL.record.LegalPerson.name_en}
                </NavLink>
              )}
            </div>
          );

        var childes = [];
        
        if (!this.isBlank(DHL.document_fields.book_davi))
          childes.push(
            <div className="text-color-base dark:text-color-base-dark flex flex-wrap pt-2">
              {DHL.lang === 'fa' ? <span className="font-bold">رده بندی دیویی: </span> : <span className="font-bold">رده بندی دیویی:</span>}
              {DHL.document_fields.book_davi}
            </div>
          );

        if (!this.isBlank(DHL.record.code1))
          childes.push(
            <div className="text-color-base dark:text-color-base-dark flex flex-wrap pt-2">
              {DHL.lang === 'fa' ? <span className="font-bold">DOI: </span> : <span className="font-bold">DOI: </span>}
              {DHL.record.code1}
            </div>
          );

        if (!this.isBlank(DHL.record.code2))
          childes.push(
            <div className="text-color-base dark:text-color-base-dark flex flex-wrap pt-2">
              {DHL.lang === 'fa' ? <span className="font-bold">شابک: </span> : <span className="font-bold">ISBN: </span>}
              {DHL.record.code2}
            </div>
          );

        if (!this.isBlank(DHL.record.code3))
          childes.push(
            <div className="text-color-base dark:text-color-base-dark flex flex-wrap pt-2">
              {DHL.lang === 'fa' ? <span className="font-bold">شابک الکترونیکی: </span> : <span className="font-bold">e-ISBN: </span>}
              {DHL.record.code3}
            </div>
          );

        if (!this.isBlank(DHL.document_fields.book_cong))
          childes.push(
            <div className="text-color-base dark:text-color-base-dark flex flex-wrap pt-2">
              {DHL.lang === 'fa' ? <span className="font-bold">رده بندی کنگره: </span> : <span className="font-bold">رده بندی کنگره: </span>}
              {DHL.document_fields.book_cong}
            </div>
          );

        if (!this.isBlank(DHL.document_fields.book_national_no))
          childes.push(
            <div className="text-color-base dark:text-color-base-dark flex flex-wrap pt-2">
              {DHL.lang === 'fa' ? <span className="font-bold">شماره کتابشناسی ملی: </span> : <span className="font-bold">شماره کتابشناسی ملی: </span>}
              {DHL.document_fields.book_national_no}
            </div>
          );

        childes.push(
          <div className="text-color-base dark:text-color-base-dark flex flex-wrap pt-2">
            {DHL.lang === 'fa' ? <span className="font-bold">شناسه ملی سند علمی: </span> : <span className="font-bold">Document National Code: </span>}
            R-{DHL.record.id}
          </div>
        );
        childes.push(
          <div className="text-color-base dark:text-color-base-dark flex flex-wrap pt-2">
            {DHL.lang === 'fa' ? <span className="font-bold">تاریخ درج در سایت: </span> : <span className="font-bold">Publish: </span>}
            {DHL.lang === 'fa' ? this.g2j(DHL.record.add_date) : this.gFormat(DHL.record.add_date)}
          </div>
        );
        childes.push(
          <div className="text-color-base dark:text-color-base-dark flex flex-wrap pt-2">
            {DHL.lang === 'fa' ? <span className="font-bold">سال انتشار: </span> : <span className="font-bold">Publish Year: </span>}
            {DHL.record.year}
          </div>
        );
        childes.push(
          <div className="text-color-base dark:text-color-base-dark flex flex-wrap pt-2">
            {DHL.lang === 'fa' ? <span className="font-bold">تعداد صفحه: </span> : <span className="font-bold">Page: </span>}
            {DHL.record.page_no}
          </div>
        );
        childes.push(
          <div className="text-color-base dark:text-color-base-dark flex flex-wrap pt-2">
            {DHL.lang === 'fa' ? <span className="font-bold">زبان: </span> : <span className="font-bold">Language: </span>}
            {this.enumString(DHL.record.language, 'Language')}
          </div>
        );
        childes.push(
          <div className="text-color-base dark:text-color-base-dark flex flex-wrap pt-2">
            {DHL.lang === 'fa' ? <span className="font-bold">دسته بندی علمی: </span> : <span className="font-bold">دسته بندی علمی: </span>}
            {DHL.science_fields.map(
              (_sc, index) =>
                !this.isNull(_sc.ScienceField) && [
                  <NavLink to={'/search/paper/sf-' + _sc.science_field_id + '/'} title={_sc.ScienceField.Name}>
                    {_sc.ScienceField.Name}
                  </NavLink>,
                  index < DHL.science_fields.length - 1 ? ' - ' : '',
                ]
            )}
          </div>
        );
        childes.push(
          <div className="text-color-base dark:text-color-base-dark flex py-2">
            {DHL.lang === 'fa' ? <span className="font-bold">مشاهده: </span> : <span className="font-bold">View: </span>}
            {this.money(DHL.record.visit)}
          </div>
        );

        resualt.push(<div className='grid grid-cols-1 md:grid-cols-2'>{childes}</div>);
      }

      if (DHL.record.document_sub_type === 4) {
        if (!this.isNull(DHL.record.LegalPerson))
          resualt.push(
            <div className="text-color-base dark:text-color-base-dark flex py-2">
              {DHL.lang === 'fa' ? <span className="font-bold">صاحب اثر: </span> : <span className="font-bold">صاحب اثر: </span>}
              <NavLink to={'/l/' + DHL.record.legal_person_id + '/'} title={DHL.record.LegalPerson.name}>
                {DHL.record.LegalPerson.name}
              </NavLink>
            </div>
          );

        if (!this.isNull(DHL.record.LegalPerson2))
          resualt.push(
            <div className="text-color-base dark:text-color-base-dark flex py-2">
              {DHL.lang === 'fa' ? <span className="font-bold">مجری: </span> : <span className="font-bold">مجری: </span>}
              <NavLink to={'/l/' + DHL.record.legal_person_id2 + '/'} title={DHL.record.LegalPerson2.name}>
                {DHL.record.LegalPerson2.name}
              </NavLink>
            </div>
          );

        var childes = [];
        childes.push(
          <div className="text-color-base dark:text-color-base-dark flex py-2">
            {DHL.lang === 'fa' ? <span className="font-bold">نوع محتوی: </span> : <span className="font-bold">نوع محتوی: </span>}
            {this.enumString(DHL.record.document_sub_type, 'report_type')}
          </div>
        );
        childes.push(
          <div className="text-color-base dark:text-color-base-dark flex py-2">
            {DHL.lang === 'fa' ? <span className="font-bold">زبان: </span> : <span className="font-bold">Language: </span>}
            {this.enumString(DHL.record.language, 'Language')}
          </div>
        );

        if (DHL.record.Province !== null)
          childes.push(
            <div className="text-color-base dark:text-color-base-dark flex py-2">
              {DHL.lang === 'fa' ? <span className="font-bold">استان موضوع گزارش: </span> : <span className="font-bold">استان موضوع گزارش: </span>}
              <NavLink to={"/province/" + DHL.record.Province.provinceId + "/"} title={DHL.record.Province.persianProvinceName}>{DHL.record.Province.persianProvinceName}</NavLink>
            </div>
          );

        if (DHL.record.City)
          childes.push(
            <div className="text-color-base dark:text-color-base-dark flex py-2">
              {DHL.lang === 'fa' ? <span className="font-bold">شهر موضوع گزارش: </span> : <span className="font-bold">شهر موضوع گزارش: </span>}
              <NavLink to={"/city/" + DHL.record.City.cityId + "/"} title={DHL.record.City.persianCityName}>{DHL.record.City.persianCityName}</NavLink>
            </div>
          );

        childes.push(
          <div className="text-color-base dark:text-color-base-dark flex py-2">
            {DHL.lang === 'fa' ? <span className="font-bold">شناسه ملی سند علمی: </span> : <span className="font-bold">Document National Code: </span>}
            R-{DHL.record.id}
          </div>
        );
        childes.push(
          <div className="text-color-base dark:text-color-base-dark flex py-2">
            {DHL.lang === 'fa' ? <span className="font-bold">تاریخ درج در سایت: </span> : <span className="font-bold">Publish: </span>}
            {DHL.lang === 'fa' ? this.g2j(DHL.record.add_date) : this.gFormat(DHL.record.add_date)}
          </div>
        );
        childes.push(
          <div className="text-color-base dark:text-color-base-dark flex py-2">
            {DHL.lang === 'fa' ? <span className="font-bold">دسته بندی علمی: </span> : <span className="font-bold">دسته بندی علمی: </span>}
            {DHL.science_fields.map(
              (_sc, index) =>
                !this.isNull(_sc.ScienceField) && [
                  <NavLink to={'/search/paper/sf-' + _sc.science_field_id + '/'} title={_sc.ScienceField.Name}>
                    {_sc.ScienceField.Name}
                  </NavLink>,
                  index < DHL.science_fields.length - 1 ? ' - ' : '',
                ]
            )}
          </div>
        );
        childes.push(
          <div className="text-color-base dark:text-color-base-dark flex py-2">
            {DHL.lang === 'fa' ? <span className="font-bold">مشاهده: </span> : <span className="font-bold">View: </span>}
            {this.money(DHL.record.visit)}
          </div>
        );
        childes.push(
          <div className="text-color-base dark:text-color-base-dark flex py-2">
            {DHL.lang === 'fa' ? <span className="font-bold">تعداد صفحات: </span> : <span className="font-bold">Pages: </span>}
            {this.money(DHL.record.page_no)}
          </div>
        );
        childes.push(
          <div className="text-color-base dark:text-color-base-dark flex py-2">
            {DHL.lang === 'fa' ? <span className="font-bold">سال انتشار: </span> : <span className="font-bold">Publish Year: </span>}
            {DHL.record.year}
          </div>
        );
        resualt.push(<div className='grid grid-cols-1 md:grid-cols-2'>{childes}</div>);
      }

      if (DHL.record.document_sub_type === 5) {
        if (!this.isNull(DHL.record.LegalPerson))
          resualt.push(
            <div className="text-color-base dark:text-color-base-dark flex py-2">
              {DHL.lang === 'fa' ? <span className="font-bold">صاحب اثر: </span> : <span className="font-bold">صاحب اثر: </span>}
              <NavLink to={'/l/' + DHL.record.legal_person_id + '/'} title={DHL.record.LegalPerson.name}>
                {DHL.record.LegalPerson.name}
              </NavLink>
            </div>
          );

        if (!this.isNull(DHL.record.LegalPerson2))
          resualt.push(
            <div className="text-color-base dark:text-color-base-dark flex py-2">
              {DHL.lang === 'fa' ? <span className="font-bold">مجری: </span> : <span className="font-bold">مجری: </span>}
              <NavLink to={'/l/' + DHL.record.legal_person_id2 + '/'} title={DHL.record.LegalPerson2.name}>
                {DHL.record.LegalPerson2.name}
              </NavLink>
            </div>
          );

        var childes = [];

        childes.push(
          <div className="text-color-base dark:text-color-base-dark flex py-2">
            {DHL.lang === 'fa' ? <span className="font-bold">نوع محتوی: </span> : <span className="font-bold">نوع محتوی: </span>}
            {this.enumString(DHL.record.document_sub_type, 'report_type')}
          </div>
        );
        childes.push(
          <div className="text-color-base dark:text-color-base-dark flex py-2">
            {DHL.lang === 'fa' ? <span className="font-bold">زبان: </span> : <span className="font-bold">Language: </span>}
            {this.enumString(DHL.record.language, 'Language')}
          </div>
        );

        if (DHL.record.Province !== null)
          childes.push(
            <div className="text-color-base dark:text-color-base-dark flex py-2">
              {DHL.lang === 'fa' ? <span className="font-bold">استان موضوع گزارش: </span> : <span className="font-bold">استان موضوع گزارش: </span>}
              <NavLink to={"/province/" + DHL.record.Province.provinceId + "/"} title={DHL.record.Province.persianProvinceName}>{DHL.record.Province.persianProvinceName}</NavLink>
            </div>
          );

        if (DHL.record.City)
          childes.push(
            <div className="text-color-base dark:text-color-base-dark flex py-2">
              {DHL.lang === 'fa' ? <span className="font-bold">شهر موضوع گزارش: </span> : <span className="font-bold">شهر موضوع گزارش: </span>}
              <NavLink to={"/city/" + DHL.record.City.cityId + "/"} title={DHL.record.City.persianCityName}>{DHL.record.City.persianCityName}</NavLink>
            </div>
          );

        childes.push(
          <div className="text-color-base dark:text-color-base-dark flex py-2">
            {DHL.lang === 'fa' ? <span className="font-bold">شناسه ملی سند علمی: </span> : <span className="font-bold">Document National Code: </span>}
            R-{DHL.record.id}
          </div>
        );
        childes.push(
          <div className="text-color-base dark:text-color-base-dark flex py-2">
            {DHL.lang === 'fa' ? <span className="font-bold">تاریخ درج در سایت: </span> : <span className="font-bold">Publish: </span>}
            {DHL.lang === 'fa' ? this.g2j(DHL.record.add_date) : this.gFormat(DHL.record.add_date)}
          </div>
        );
        childes.push(
          <div className="text-color-base dark:text-color-base-dark flex py-2">
            {DHL.lang === 'fa' ? <span className="font-bold">دسته بندی علمی: </span> : <span className="font-bold">دسته بندی علمی: </span>}
            {DHL.science_fields.map(
              (_sc, index) =>
                !this.isNull(_sc.ScienceField) && [
                  <NavLink to={'/search/paper/sf-' + _sc.science_field_id + '/'} title={_sc.ScienceField.Name}>
                    {_sc.ScienceField.Name}
                  </NavLink>,
                  index < DHL.science_fields.length - 1 ? ' - ' : '',
                ]
            )}
          </div>
        );
        childes.push(
          <div className="text-color-base dark:text-color-base-dark flex py-2">
            {DHL.lang === 'fa' ? <span className="font-bold">مشاهده: </span> : <span className="font-bold">View: </span>}
            {this.money(DHL.record.visit)}
          </div>
        );
        childes.push(
          <div className="text-color-base dark:text-color-base-dark flex py-2">
            {DHL.lang === 'fa' ? <span className="font-bold">تعداد صفحات: </span> : <span className="font-bold">Pages: </span>}
            {this.money(DHL.record.page_no)}
          </div>
        );
        childes.push(
          <div className="text-color-base dark:text-color-base-dark flex py-2">
            {DHL.lang === 'fa' ? <span className="font-bold">سال انتشار: </span> : <span className="font-bold">Publish Year: </span>}
            {DHL.record.year}
          </div>
        );

        resualt.push(<div className='grid grid-cols-1 md:grid-cols-2'>{childes}</div>);
      }

      if (DHL.record.document_sub_type === 6) {
        if (!this.isNull(DHL.record.LegalPerson))
          resualt.push(
            <div className="text-color-base dark:text-color-base-dark flex py-2">
              {DHL.lang === 'fa' ? <span className="font-bold">صاحب اثر: </span> : <span className="font-bold">صاحب اثر: </span>}
              <NavLink to={'/l/' + DHL.record.legal_person_id + '/'} title={DHL.record.LegalPerson.name}>
                {DHL.record.LegalPerson.name}
              </NavLink>
            </div>
          );
        if (!this.isNull(DHL.record.LegalPerson2))
          resualt.push(
            <div className="text-color-base dark:text-color-base-dark flex py-2">
              {DHL.lang === 'fa' ? <span className="font-bold">مجری: </span> : <span className="font-bold">مجری: </span>}
              <NavLink to={'/l/' + DHL.record.legal_person_id2 + '/'} title={DHL.record.LegalPerson2.name}>
                {DHL.record.LegalPerson2.name}
              </NavLink>
            </div>
          );

        var childes = [];

        childes.push(
          <div className="text-color-base dark:text-color-base-dark flex py-2">
            {DHL.lang === 'fa' ? <span className="font-bold">نوع محتوی: </span> : <span className="font-bold">نوع محتوی: </span>}
            {this.enumString(DHL.record.document_sub_type, 'report_type')}
          </div>
        );
        childes.push(
          <div className="text-color-base dark:text-color-base-dark flex py-2">
            {DHL.lang === 'fa' ? <span className="font-bold">زبان: </span> : <span className="font-bold">Language: </span>}
            {this.enumString(DHL.record.language, 'Language')}
          </div>
        );

        if (DHL.record.Province !== null)
          childes.push(
            <div className="text-color-base dark:text-color-base-dark flex py-2">
              {DHL.lang === 'fa' ? <span className="font-bold">استان موضوع گزارش: </span> : <span className="font-bold">استان موضوع گزارش: </span>}
              {DHL.record.Province.persianProvinceName}
            </div>
          );

        if (DHL.record.City)
          childes.push(
            <div className="text-color-base dark:text-color-base-dark flex py-2">
              {DHL.lang === 'fa' ? <span className="font-bold">شهر موضوع گزارش: </span> : <span className="font-bold">شهر موضوع گزارش: </span>}
              <NavLink to={"/city/" + DHL.record.City.cityId + "/"} title={DHL.record.City.persianCityName}>{DHL.record.City.persianCityName}</NavLink>
            </div>
          );

        if (!this.isBlank(DHL.record.code1))
          childes.push(
            <div className="text-color-base dark:text-color-base-dark flex py-2">
              {DHL.lang === 'fa' ? <span className="font-bold">DOI: </span> : <span className="font-bold">DOI: </span>}
              {DHL.record.code1}
            </div>
          );

        childes.push(
          <div className="text-color-base dark:text-color-base-dark flex py-2">
            {DHL.lang === 'fa' ? <span className="font-bold">شناسه ملی سند علمی: </span> : <span className="font-bold">Document National Code: </span>}
            R-{DHL.record.id}
          </div>
        );
        
        childes.push(
          <div className="text-color-base dark:text-color-base-dark flex py-2">
            {DHL.lang === 'fa' ? <span className="font-bold">تاریخ درج در سایت: </span> : <span className="font-bold">Publish: </span>}
            {DHL.lang === 'fa' ? this.g2j(DHL.record.add_date) : this.gFormat(DHL.record.add_date)}
          </div>
        );
        childes.push(
          <div className="text-color-base dark:text-color-base-dark flex py-2">
            {DHL.lang === 'fa' ? <span className="font-bold">دسته بندی علمی: </span> : <span className="font-bold">دسته بندی علمی: </span>}
            {DHL.science_fields.map(
              (_sc, index) =>
                !this.isNull(_sc.ScienceField) && [
                  <NavLink to={'/search/paper/sf-' + _sc.science_field_id + '/'} title={_sc.ScienceField.Name}>
                    {_sc.ScienceField.Name}
                  </NavLink>,
                  index < DHL.science_fields.length - 1 ? ' - ' : '',
                ]
            )}
          </div>
        );
        childes.push(
          <div className="text-color-base dark:text-color-base-dark flex py-2">
            {DHL.lang === 'fa' ? <span className="font-bold">مشاهده: </span> : <span className="font-bold">View: </span>}
            {this.money(DHL.record.visit)}
          </div>
        );

        childes.push(
          <div className="text-color-base dark:text-color-base-dark flex py-2">
            {DHL.lang === 'fa' ? <span className="font-bold">تعداد صفحات: </span> : <span className="font-bold">Pages: </span>}
            {this.money(DHL.record.page_no)}
          </div>
        );
        childes.push(
          <div className="text-color-base dark:text-color-base-dark flex py-2">
            {DHL.lang === 'fa' ? <span className="font-bold">سال انتشار: </span> : <span className="font-bold">Publish Year: </span>}
            {DHL.record.year}
          </div>
        );


        resualt.push(<div className='grid grid-cols-1 md:grid-cols-2'>{childes}</div>);
      }

      if (DHL.record.document_sub_type === 8) {
        if (!this.isNull(DHL.record.LegalPerson))
          resualt.push(
            <div className="text-color-base dark:text-color-base-dark flex py-2">
              {DHL.lang === 'fa' ? <span className="font-bold">صاحب اثر: </span> : <span className="font-bold">صاحب اثر: </span>}
              <NavLink to={'/l/' + DHL.record.legal_person_id + '/'} title={DHL.record.LegalPerson.name}>
                {DHL.record.LegalPerson.name}
              </NavLink>
            </div>
          );

        if (!this.isNull(DHL.record.LegalPerson2))
          resualt.push(
            <div className="text-color-base dark:text-color-base-dark flex py-2">
              {DHL.lang === 'fa' ? <span className="font-bold">مجری: </span> : <span className="font-bold">مجری: </span>}
              <NavLink to={'/l/' + DHL.record.legal_person_id2 + '/'} title={DHL.record.LegalPerson2.name}>
                {DHL.record.LegalPerson2.name}
              </NavLink>
            </div>
          );

        var childes = [];
        childes.push(
          <div className="text-color-base dark:text-color-base-dark flex py-2">
            {DHL.lang === 'fa' ? <span className="font-bold">نوع محتوی: </span> : <span className="font-bold">نوع محتوی: </span>}
            {this.enumString(DHL.record.document_sub_type, 'report_type')}
          </div>
        );
        childes.push(
          <div className="text-color-base dark:text-color-base-dark flex py-2">
            {DHL.lang === 'fa' ? <span className="font-bold">زبان: </span> : <span className="font-bold">Language: </span>}
            {this.enumString(DHL.record.language, 'Language')}
          </div>
        );

        if (DHL.record.Province !== null)
          childes.push(
            <div className="text-color-base dark:text-color-base-dark flex py-2">
              {DHL.lang === 'fa' ? <span className="font-bold">استان: </span> : <span className="font-bold">استان: </span>}
              <NavLink to={"/province/" + DHL.record.Province.provinceId + "/"} title={DHL.record.Province.persianProvinceName}>{DHL.record.Province.persianProvinceName}</NavLink>
            </div>
          );

        if (DHL.record.City)
          childes.push(
            <div className="text-color-base dark:text-color-base-dark flex py-2">
              {DHL.lang === 'fa' ? <span className="font-bold">شهر: </span> : <span className="font-bold">شهر: </span>}
              <NavLink to={"/city/" + DHL.record.City.cityId + "/"} title={DHL.record.City.persianCityName}>{DHL.record.City.persianCityName}</NavLink>
            </div>
          );

        childes.push(
          <div className="text-color-base dark:text-color-base-dark flex py-2">
            {DHL.lang === 'fa' ? <span className="font-bold">شناسه ملی سند علمی: </span> : <span className="font-bold">Document National Code: </span>}
            R-{DHL.record.id}
          </div>
        );
        childes.push(
          <div className="text-color-base dark:text-color-base-dark flex py-2">
            {DHL.lang === 'fa' ? <span className="font-bold">تاریخ درج در سایت: </span> : <span className="font-bold">Publish: </span>}
            {DHL.lang === 'fa' ? this.g2j(DHL.record.add_date) : this.gFormat(DHL.record.add_date)}
          </div>
        );
        childes.push(
          <div className="text-color-base dark:text-color-base-dark flex py-2">
            {DHL.lang === 'fa' ? <span className="font-bold">دسته بندی علمی: </span> : <span className="font-bold">دسته بندی علمی: </span>}
            {DHL.science_fields.map(
              (_sc, index) =>
                !this.isNull(_sc.ScienceField) && [
                  <NavLink to={'/search/paper/sf-' + _sc.science_field_id + '/'} title={_sc.ScienceField.Name}>
                    {_sc.ScienceField.Name}
                  </NavLink>,
                  index < DHL.science_fields.length - 1 ? ' - ' : '',
                ]
            )}
          </div>
        );
        childes.push(
          <div className="text-color-base dark:text-color-base-dark flex py-2">
            {DHL.lang === 'fa' ? <span className="font-bold">مشاهده: </span> : <span className="font-bold">View: </span>}
            {this.money(DHL.record.visit)}
          </div>
        );
        childes.push(
          <div className="text-color-base dark:text-color-base-dark flex py-2">
            {DHL.lang === 'fa' ? <span className="font-bold">تعداد صفحات: </span> : <span className="font-bold">Pages: </span>}
            {this.money(DHL.record.page_no)}
          </div>
        );
        childes.push(
          <div className="text-color-base dark:text-color-base-dark flex py-2">
            {DHL.lang === 'fa' ? <span className="font-bold">سال انتشار: </span> : <span className="font-bold">Publish Year: </span>}
            {DHL.record.year}
          </div>
        );
        resualt.push(<div className='grid grid-cols-1 md:grid-cols-2'>{childes}</div>);
      }

      if (DHL.record.document_sub_type === 1 || DHL.record.document_sub_type === 2) {
        
        if (DHL.record.document_sub_type === 1 && !this.isNull(DHL.record.LegalPerson)){
          resualt.push(
            <div className="text-color-base dark:text-color-base-dark flex py-2 flex-wrap">
              {DHL.lang === 'fa' ? <span className="font-bold">محل انتشار: </span> : <span className="font-bold">Publish place: </span>}
              {this.getEditLink(DHL.record.LegalPerson, 'legalperson')}
              <NavLink to={'/l/' + DHL.record.LegalPerson.person_id + '/'} title={this.T(DHL.record.LegalPerson, 'legal_person_name')}>
                {this.T(DHL.record.LegalPerson, 'legal_person_name')}
              </NavLink>
            </div>
          );
        }

        if (DHL.record.document_sub_type === 2 && !this.isNull(DHL.record.LegalPerson.Parent)){
            resualt.push(
              <div className="text-color-base dark:text-color-base-dark flex py-2 flex-wrap">
                {DHL.lang === 'fa' ? <span className="font-bold">محل انتشار: </span> : <span className="font-bold">Publish place: </span>}
                {this.getEditLink(DHL.record.LegalPerson.Parent, 'legalperson')}
                {DHL.lang === 'fa' ? (
                  <NavLink to={this.getLegalLink(DHL.record.LegalPerson)} title={DHL.record.LegalPerson.Parent.name}>
                    {DHL.record.LegalPerson.Parent.name}، دوره: {DHL.record.LegalPerson.volume}، شماره: {DHL.record.LegalPerson.issue}
                  </NavLink>
                ) : (
                  <NavLink to={this.getLegalLink(DHL.record.LegalPerson)} title={DHL.record.LegalPerson.Parent.name}>
                    {DHL.record.LegalPerson.Parent.name_en}، Vol: {DHL.record.LegalPerson.volume}، Issue: {DHL.record.LegalPerson.issue}
                  </NavLink>
                )}
              </div>
            );
        }

        resualt.push(
          <div className='grid grid-cols-1 md:grid-cols-2'>
            <div className="text-color-base dark:text-color-base-dark flex py-2">
              {DHL.lang === 'fa' ? <span className="font-bold">سال انتشار: </span> : <span className="font-bold">Publish Year: </span>}
              {" " + DHL.record.year}
            </div>
            <div className="text-color-base dark:text-color-base-dark flex py-2">
              {DHL.lang === 'fa' ? <span className="font-bold">نوع سند: </span> : <span className="font-bold">Type: </span>}
              {DHL.record.document_sub_type === 1 ? (DHL.lang === 'fa' ? " مقاله کنفرانسی" : "Conference paper") : DHL.record.document_sub_type === 2 ? (DHL.lang === 'fa' ? " مقاله ژورنالی" : "Journal paper") : ""}
            </div>
            <div className="text-color-base dark:text-color-base-dark flex py-2">
              {DHL.lang === 'fa' ? <span className="font-bold">زبان: </span> : <span className="font-bold">Language: </span>}
              {" " + this.enumString(DHL.record.language, 'Language')}
            </div>
            <div className="text-color-base dark:text-color-base-dark flex py-2">
              {DHL.lang === 'fa' ? <span className="font-bold">مشاهده: </span> : <span className="font-bold">View: </span>}
              {" " + this.money(DHL.record.visit)}
            </div>
          </div>
        );
      }

      var docType = " مقاله پیش چاپ";
      if (DHL.record.document_sub_type === 11) docType=" پایان نامه کارشناسی ارشد";
      if (DHL.record.document_sub_type === 12) docType=" پایان نامه دکترا";
      if (DHL.record.document_sub_type === 13) docType=" سمینار دوره کارشناسی";
      if (DHL.record.document_sub_type === 14) docType=" سمینار کارشناسی ارشد";
      if (DHL.record.document_sub_type === 15) docType=" پروپوزال پایان نامه کارشناسی ارشد";
      if (DHL.record.document_sub_type === 16) docType=" پروپوزال پایان نامه دکترا";

      if (DHL.record.document_sub_type === 9 || DHL.record.document_sub_type === 10 || DHL.record.document_sub_type === 11
        || DHL.record.document_sub_type === 12|| DHL.record.document_sub_type === 13|| DHL.record.document_sub_type === 14
        || DHL.record.document_sub_type === 15|| DHL.record.document_sub_type === 16) {
        
        resualt.push(
          <div className='grid grid-cols-1 md:grid-cols-2'>
            <div className="text-color-base dark:text-color-base-dark flex py-2">
              {DHL.lang === 'fa' ? <span className="font-bold">سال: </span> : <span className="font-bold">Publish Year: </span>}
              {" " + DHL.record.year}
            </div>
            <div className="text-color-base dark:text-color-base-dark flex py-2">
              {DHL.lang === 'fa' ? <span className="font-bold">نوع سند: </span> : <span className="font-bold">Type: </span>}
              {(DHL.lang === 'fa' ? docType : "Preprint paper")}
            </div>
            <div className="text-color-base dark:text-color-base-dark flex py-2">
              {DHL.lang === 'fa' ? <span className="font-bold">زبان: </span> : <span className="font-bold">Language: </span>}
              {" " + this.enumString(DHL.record.language, 'Language')}
            </div>
            <div className="text-color-base dark:text-color-base-dark flex py-2">
              {DHL.lang === 'fa' ? <span className="font-bold">مشاهده: </span> : <span className="font-bold">View: </span>}
              {" " + this.money(DHL.record.visit)}
            </div>
          </div>
        );
      }

      if (DHL.record.document_status === 3){
        resualt.push(
          <div className="text-color-base dark:text-color-base-dark flex py-2">
            {DHL.record.document_type === 3 ?
              <p>نسخه کامل {this.getCaption()} منتشر نشده است و در دسترس نیست.</p>
            :
              DHL.record.document_type === 1 ?
                DHL.record.document_sub_type === 1 ?
                  <p>نسخه کامل {this.getCaption()} در کنفرانس ارائه نشده است و در دسترس نیست.</p>
                :
                  <p>نسخه کامل {this.getCaption()} در مجله ارائه نشده است و در دسترس نیست.</p>
              :
                <p>نسخه کامل {this.getCaption()} ارائه نشده است و در دسترس نیست.</p>
            }
          </div>
        );
      }
      else {
        if (
          (DHL.record.page_no < 5 || DHL.record.document_status === 0 || DHL.record.credit === 0) && !this.isEmpty(DHL.medias)
        ){
            resualt.push(
              <div className="text-color-base dark:text-color-base-dark flex py-2">
                <p>
                  متن کامل این {this.getCaption()} منتشر نشده است و فقط به صورت چکیده یا چکیده مبسوط در پایگاه موجود می باشد.
                  <br />
                  توضیح: معمولا کلیه مقالاتی که کمتر از ۵ صفحه باشند در پایگاه سیویلیکا اصل {this.getCaption()} (فول تکست) محسوب نمی شوند و فقط کاربران عضو بدون کسر اعتبار می توانند فایل آنها را دانلود
                  نمایند.
                </p>
              </div>
            );
          if (!this.isNull(DHL.currentPerson)){
            if (this.hasMedia(1) || this.hasMedia(2) || this.hasMedia(8)) {
              resualt.push(<div className={'flex flex-col justify-center fixed inset-x-0 bottom-0 bg-white dark:bg-light-600 z-99 lg:relative border-t dark:border-light-700 lg:border-t-0'}>
                  <div className="flex  justify-center">
                    <a title={DHL.lang === 'fa' ? 'دانلود فایل ' + this.getCaption() : 'Download paper'} href={'https://civilica.com/doc/' + DHL.record.id + '/download/' } className={"bg-brand flex items-center btn hover:bg-brand/90 text-white px-4 py-2 text-center my-2 rounded" + (!this.isNull(DHL.currentIpPerson) ? " mb-8" : "")}>
                    {this.getSVGIcon("download","h-6 w-6 rtl:ml-2 ltr:mr-2")}
                    دانلود فایل {this.getCaption()}
                    </a>
                  </div>
                </div>);
            }
          }
        }
        else {
          if (this.isEmpty(DHL.medias) && DHL.record.document_type!==4){
            resualt.push(
              <div className="text-color-base dark:text-color-base-dark py-2">
                این {this.getCaption()} فقط به صورت چکیده توسط دبیرخانه ارسال شده است و فایل کامل قابل دریافت نیست. برای یافتن {this.getCaptions()} دارای فایل کامل، از بخش [<NavLink to="/search/paper/" className="font-bold" title='جستجوی مقالات فارسی'>جستجوی مقالات فارسی</NavLink>] اقدام فرمایید.
              </div>
            );
          }
          
          if ((DHL.record.page_no < 5 || DHL.record.document_status === 0 || DHL.record.credit === 0) && this.isNull(DHL.currentPerson) && DHL.record.document_type!==4){
            resualt.push(
              <div className="text-color-base dark:text-color-base-dark flex py-2">
                <p>نسخه کامل این {this.getCaption()} ارائه نشده است و در دسترس نمی باشد</p>
              </div>
            );
          }
          else {
            if (this.hasMedia(1)) {
              resualt.push(
                <div className="pt-2">
                  {DHL.lang === 'fa' ? (
                    <p>
                      فایل این {this.getCaption()} در {DHL.record.page_no} صفحه با فرمت <NavLink title="دانلود مقاله pdf" to={'/doc/' + DHL.record.id + '/download/' } className='text-red-600 font-bold'>PDF</NavLink>{(this.hasMedia(2) || this.hasMedia(8)) ? [" و ",<NavLink title="دانلود مقاله word" to={'/doc/' + DHL.record.id + '/download/' } className='text-indigo-500 font-bold'>WORD</NavLink>]: null} قابل دریافت می باشد
                    </p>
                  ) : (
                    <p>
                      This {this.getCaption()} With {DHL.record.page_no} Page And <NavLink title="Download pdf" to={'/doc/' + DHL.record.id + '/download/' } className='text-red-600 font-bold'>PDF</NavLink>{(this.hasMedia(2) || this.hasMedia(8)) ? [" and ",<NavLink title="Download word" to={'/doc/' + DHL.record.id + '/download/' } className='text-indigo-500 font-bold'>WORD</NavLink>]: null} Format Ready To Download
                    </p>
                  )}
                </div>
              );
            }

            if (this.hasMedia(1) || this.hasMedia(2) || this.hasMedia(8)) {
              resualt.push(<div className={'flex flex-col justify-center fixed inset-x-0 bottom-0 bg-white dark:bg-light-600 z-99 lg:relative border-t dark:border-light-700 lg:border-t-0'}>
                  <div className="flex  justify-center">
                    <a title={DHL.lang === 'fa' ? 'دانلود فایل کامل ' + this.getCaption() : 'Download paper'} href={'https://civilica.com/doc/' + DHL.record.id + '/download/' } className={"bg-brand flex items-center btn hover:bg-brand/90 text-white px-4 py-2 text-center my-2 rounded" + (!this.isNull(DHL.currentIpPerson) ? " mb-8" : "")}>
                    {this.getSVGIcon("download","h-6 w-6 rtl:ml-2 ltr:mr-2")}
                      {DHL.lang === 'fa' ? 'دانلود فایل کامل ' : 'DOWNLOAD '}{this.getCaption()}
                    </a>
                  </div>
                </div>);
              resualt.push(<div className={'hidden flex flex-col justify-center fixed inset-x-0 bottom-0 bg-white dark:bg-light-600 z-99 lg:relative border-t dark:border-light-700 lg:border-t-0'} id="buy_button">
                  <div className="flex  justify-center">
                    <a title={DHL.lang === 'fa' ? 'دانلود فایل کامل ' + this.getCaption() : 'Download paper'} href={'https://civilica.com/doc/' + DHL.record.id + '/download/' } className={"bg-brand flex items-center btn hover:bg-brand/90 text-white px-4 py-2 text-center my-2 rounded" + (!this.isNull(DHL.currentIpPerson) ? " mb-8" : "")}>
                    {this.getSVGIcon("download","h-6 w-6 rtl:ml-2 ltr:mr-2")}
                      {DHL.lang === 'fa' ? 'دانلود فایل کامل ' : 'DOWNLOAD '}{this.getCaption()}
                    </a>
                  </div>
                </div>);
            }
          }
        }
      }

      var imageUrl = this.toImageUrl(DHL.record, (DHL.record.document_type === 1 ? 'paper' : DHL.record.document_type === 4 ? 'preprint' : 'report'), true,true);
      return <div className="p-4 bg-white shadow-me border rounded dark:bg-light-600 mb-4">
          <header className='col-span-12 lg:col-span-7 xl:col-span-8 mb-4'>
          <h1 className={"font-bold h_title mb-2 border-b pb-2" + (DHL.record.language == 2 ? " ltr " : "")}>{this.getEditLink(DHL.record,"paper")}{DHL.record.language == 2 ? this.toEnglishNumber(this.getPaperTitle()) : this.getPaperTitle()}</h1>
          </header>
          <div className=' flex flex-col md:flex-row' style={{"white-space": "break-spaces"}}>
            <div className="rtl:ml-2 ltr:mr-2 flex flex-col flex-auto ">
              {resualt}
            </div>
            {!this.isBlank(imageUrl) &&
              <div className="flex-shrink-0">
                <div className="mx-auto mb-2 md:mb-0 bgImage" style={{"backgroundImage": "url('" + imageUrl + "')","height": "220px","width": "160px"}}></div>
              </div>
            }
          </div>
        </div>
    }

    return resualt;
  }
  renderKeywords() {
    var DHL = this.state.dataHolder;
    if (this.state.template !== 1) return null;

    var tgs = this.getPaperKeywords();

    if (this.isBlank(tgs)) return null;

    var tags = tgs.replace(/،/g, ',').replace(/;/g, ',').replace(/؛/g, ',').replace(/–/g, ',').split(',');

    if (this.isEmpty(tags)) return;
    
    return  <div className="text-color-base dark:text-color-base-dark pt-2 space-x-1 rtl:space-x-reverse p-4 my-4 bg-white shadow-me border rounded dark:bg-light-600">
              {DHL.lang === 'fa' ? <p className="font-bold h_title mb-2 border-b pb-2">{"کلیدواژه های " + " " + this.getPaperTitle()}: </p> : <p className="font-bold h_title mb-2 border-b pb-2">{this.getPaperTitle() + " Keywords"}: </p>}
              <div className={DHL.record.language === 2 ? 'ltr' : ''}>
                {tags.map((v, index) =>
                  v.trim().split(' ').length > 3
                    ? [<span>{v}</span>, index < tags.length - 1 ? (DHL.lang === 'fa' ? ' ، ' : ' , ') : ' ']
                    : [
                        <a href={'/search/paper/k-' + encodeURI(v.trim()) + '/'} className="text-brand hover:text-brand/90 font-medium " title={v}>
                          {v}
                        </a>,
                        index < tags.length - 1 ? (DHL.lang === 'fa' ? ' ، ' : ' , ') : ' ',
                      ]
                )}
              </div>
              </div>
  }
  setIsOpen() {
    if (typeof window !== 'undefined') {
      document.getElementById('share_modal').classList.toggle('hidden');
      document.getElementById('bg_share_modal').classList.toggle('hidden');
      document.getElementById('share_modal').classList.toggle('flex');
    }
  }
  addDocumentToFav() {
    this.httpPost('/ajax/add_fav/', { object_id: this.state.dataHolder.record.id })
    .then((dataHolder) => {
      if (dataHolder.status === 0) {
        this.showErrorToast(dataHolder.message);
      } else {
        this.showSuccessToast('مقاله به لیست علاقه مندی شما اضافه شد.');
        var dt = this.state.dataHolder;
        dt.fav = 1;
        this.setState({ dataHolder: dt });
      }
    })
    .catch((err) => {      
      this.showErrorToast("سامانه قادر به اجرای درخواست شما نیست");
    });
  }
  removeDocumentFromFav() {    
    this.httpPost('/ajax/remove_fav/', { object_id: this.state.dataHolder.record.id })
    .then((dataHolder) => {      
      this.showSuccessToast('مقاله از لیست علاقه مندی های شما حذف شد.');

      var dt = this.state.dataHolder;
      dt.fav = 0;
      this.setState({ dataHolder: dt });
    })
    .catch((err) => {      
      this.showErrorToast("سامانه قادر به اجرای درخواست شما نیست");
    });
  }
  claim(){
    if (!this.state.showClaim) return null;
    else{
        return <div onClick={e=>this.setState({showClaim:false})} style={{ "position": "fixed", "width": "100%", "height": "100%", "left": "0", "top": "0", "backgroundColor": "#00000047", "z-index": "9999999999" }}>
                    <div style={{ "width": "350px", "margin": "10% auto", "backgroundColor": "white", "padding": "20px", "border-radius": "4px" }}>
                        <p>اگر شما نویسنده {this.getCaption()} <b>{this.getPaperTitle()}</b> هستید میتوانید به صورت رایگان در پایگاه سیویلیکا عضو شوید و بعد از عضویت نسبت به تکمیل رزومه خود اقدام نمایید</p>
                        <p>بعد از عضویت این مقاله در لیست مقالات پیشنهادی شما قرار خواهد گرفت و میتوانید مقاله را به رزومه خود اختصاص دهید</p>
                        <NavLink to="/register/" className={"bg-brand flex items-center btn hover:bg-brand/90 text-white px-4 py-2 text-center my-2 rounded" + (!this.isNull(this.state.dataHolder.currentIpPerson) ? " mb-8" : "")}>هم اکنون عضو شوید</NavLink>
                    </div>
                </div>
    }
  }
  renderPreface(){
    let preface_fa = this.state.dataHolder.document_fields.preface_fa;
    if (preface_fa === "") return null;
    return  <div className="p-4 bg-white shadow-me border rounded dark:bg-light-600 mb-4">
              <p className="font-bold h_title mb-2 border-b pb-2">پیش گفتار {this.getCaption()}</p>
              <div className="prose max-w-none my-6 text-color-black text-justify">
                <div dangerouslySetInnerHTML={{__html: preface_fa}}></div>
              </div>
            </div>
  }
  renderBackground(){
    let background = this.state.dataHolder.document_fields.background;
    if (this.isBlank(background)) return null;
    return  <div className="p-4 bg-white shadow-me border rounded dark:bg-light-600 mb-4">
              <p className="font-bold h_title mb-2 border-b pb-2">مقدمه/پیشینه تحقیق</p>
              <div className="prose max-w-none my-6 text-color-black text-justify">
                <div dangerouslySetInnerHTML={{__html: background}}></div>
              </div>
            </div>
  }
  renderMethods(){
    let methods = this.state.dataHolder.document_fields.methods;
    if (this.isBlank(methods)) return null;
    return  <div className="p-4 bg-white shadow-me border rounded dark:bg-light-600 mb-4">
              <p className="font-bold h_title mb-2 border-b pb-2">روش ها</p>
              <div className="prose max-w-none my-6 text-color-black text-justify">
                <div dangerouslySetInnerHTML={{__html: methods}}></div>
              </div>
            </div>
  }
  renderResults(){
    let results = this.state.dataHolder.document_fields.results;
    if (this.isBlank(results)) return null;
    return  <div className="p-4 bg-white shadow-me border rounded dark:bg-light-600 mb-4">
              <p className="font-bold h_title mb-2 border-b pb-2">نتایج</p>
              <div className="prose max-w-none my-6 text-color-black text-justify">
                <div dangerouslySetInnerHTML={{__html: results}}></div>
              </div>
            </div>
  }
  renderDiscussion(){
    let discussion = this.state.dataHolder.document_fields.discussion;
    if (this.isBlank(discussion)) return null;
    return  <div className="p-4 bg-white shadow-me border rounded dark:bg-light-600 mb-4">
              <p className="font-bold h_title mb-2 border-b pb-2">بحث ها</p>
              <div className="prose max-w-none my-6 text-color-black text-justify">
                <div dangerouslySetInnerHTML={{__html: discussion}}></div>
              </div>
            </div>
  }
  renderConclusions(){
    let conclusions = this.state.dataHolder.document_fields.conclusions;
    if (this.isBlank(conclusions)) return null;
    return  <div className="p-4 bg-white shadow-me border rounded dark:bg-light-600 mb-4">
              <p className="font-bold h_title mb-2 border-b pb-2">نتیجه گیری</p>
              <div className="prose max-w-none my-6 text-color-black text-justify">
                <div dangerouslySetInnerHTML={{__html: conclusions}}></div>
              </div>
            </div>
  }
  renderFigures(){
    let figures = this.state.dataHolder.document_fields.figures;
    if (this.isBlank(figures)) return null;
    return  <div className="p-4 bg-white shadow-me border rounded dark:bg-light-600 mb-4">
              <p className="font-bold h_title mb-2 border-b pb-2">تصاویر</p>
              <div className="prose max-w-none my-6 text-color-black text-justify">
                {JSON.parse(this.state.dataHolder.document_fields.figures).map(img=><a href={"/media/pp/" + img } target='_blank'><img src={"/media/pp/" + img } style={{"width":"100px","height":"100px","border": "solid 1px gray"}} /></a>)}
              </div>
            </div>
  }
  renderToc(){
      let toc_fa = this.state.dataHolder.document_fields.toc_fa;
      if (toc_fa === "") return null;
      return <div className="p-4 bg-white shadow-me border rounded dark:bg-light-600 mb-4">
                <p className="font-bold h_title mb-2 border-b pb-2">فهرست مطالب {this.getCaption()}</p>
                <div className={"prose max-w-none my-6 text-color-black text-justify " + (this.state.showTOC ? "" : "hiddenLarge")}>
                  <div dangerouslySetInnerHTML={{__html: toc_fa}}></div>
                  <span className='showLarge' onClick={e=> this.setState({showTOC:true})}>نمایش کامل متن</span>
                </div>
              </div>
  }
  downloadExportContent(filename, text) {
    var element = document.createElement('a');
    element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
    element.setAttribute('download', filename);
  
    element.style.display = 'none';
    document.body.appendChild(element);
  
    element.click();
  
    document.body.removeChild(element);
  }
  export(e,forUnique){
    let bibType = document.getElementById("bibType_"+forUnique);
    bibType = bibType.options[bibType.selectedIndex].text;
    let paper = this.state.dataHolder.record;

    let fileName = "";
    let Content = ""
    if (bibType === "BibTex")
    {
        fileName = ".bib";
        if(paper.document_type === 3){
          Content="\r\n\r\n@inproceedings{R-" + paper.id + ",\r\n";
          Content += "author = {";
          let index = 0;
          paper.Authors.forEach(_au=>{
              if (index > 0) Content += " and ";
              index++;
              Content += _au.lname + ", " + _au.fname;
          });
          Content +="},\r\n";
          Content +="title = {" + this.getPaperTitle() + "},\r\n";
          if (paper.document_sub_type === 1 && !this.isNull(paper.LegalPerson) )
          {
              Content +="booktitle = {" + paper.LegalPerson.name +"},\r\n";
              Content +="publisher = {},\r\n";
          }
          Content +="year = {" + paper.year + "},\r\n"
          Content +="url = {https://civilica.com/doc/" + paper.id + "},\r\n"
          Content +="}";
        }
        if(paper.document_sub_type === 1){
            Content="\r\n\r\n@inproceedings{" + paper.coi + ",\r\n";
            Content += "author = {";
            let index = 0;
            paper.Authors.forEach(_au=>{
                if (index > 0) Content += " and ";
                index++;
                Content += _au.lname + ", " + _au.fname;
            });
            Content +="},\r\n";
            Content +="title = {" + this.getPaperTitle() + "},\r\n";
            if (paper.document_sub_type === 1 && !this.isNull(paper.LegalPerson) )
            {
                Content +="booktitle = {" + paper.LegalPerson.name +"},\r\n";
                Content +="publisher = {},\r\n";
            }
            Content +="year = {" + paper.year + "},\r\n"
            Content +="url = {https://civilica.com/doc/" + paper.id + "},\r\n"
            Content +="}";
        }
        if(paper.document_sub_type === 2){
            Content = "\r\n\r\n@article{" + paper.coi + ",\r\n";
            Content += "author = {";
            let index = 0;
            paper.Authors.forEach(_au=>{
                if (index > 0) Content += " and ";
                index++;
                Content += _au.lname + ", " + _au.fname;
            });
            Content +="},\r\n";
            Content +="title = {" + this.getPaperTitle() + "},\r\n";
            if (paper.document_sub_type === 2)
            {
                if (!this.isNull(paper.LegalPerson))
                {
                    if (!this.isNull(paper.LegalPerson.Parent))
                    {
                        Content +="journal = {" + paper.LegalPerson.Parent.name +"},\r\n";
                        Content +="volume = {" + paper.LegalPerson.Parent.volume + "},\r\n";
                        Content +="number = {" + paper.LegalPerson.Parent.issue + "},\r\n";
                    }
                }
            }
            Content +="year = {" + paper.year + "},\r\n\r\n";
            Content +="url = {https://civilica.com/doc/" + paper.id + "},\r\n";
            Content +="}";
        }
    }
    if (bibType === "EndNote")
    {
        fileName = ".enw";
        if(paper.document_type === 3){
          Content="\r\n\r\n%0 Research\r\n";
          Content += "%A ";
          let index = 0;
          paper.Authors.forEach(_au=>{
              if (index > 0) Content += "\r\n%A ";
              index++;
              Content += _au.lname + ", " + _au.fname;
          });
          Content +="\r\n";
          Content += "%T " + this.getPaperTitle() + "\r\n";
          if (!this.isNull(paper.LegalPerson))
          {
              Content += "%B " + paper.LegalPerson.name +"\r\n";
              Content += "%I \r\n";
          }
          Content += "%U https://civilica.com/doc/" + paper.id + "\r\n";
          Content += "%D " + paper.year + "\r\n";
      }
        if(paper.document_sub_type === 1){
            Content="\r\n\r\n%0 Conference Paper\r\n";
            Content += "%A ";
            let index = 0;
            paper.Authors.forEach(_au=>{
                if (index > 0) Content += "\r\n%A ";
                index++;
                Content += _au.lname + ", " + _au.fname;
            });
            Content +="\r\n";
            Content += "%T " + this.getPaperTitle() + "\r\n";
            if (!this.isNull(paper.LegalPerson))
            {
                Content += "%B " + paper.LegalPerson.name +"\r\n";
                Content += "%I \r\n";
            }
            Content += "%U https://civilica.com/doc/" + paper.id + "\r\n";
            Content += "%D " + paper.year + "\r\n";
        }
        if(paper.document_sub_type === 2){
            Content="\r\n\r\n%0 Journal Article\r\n";
            Content += "%A ";
            let index = 0;
            paper.Authors.forEach(_au=>{
                if (index > 0) Content += "\r\n%A ";
                index++;
                Content += _au.lname + ", " + _au.fname;
            });
            Content +="\r\n";
            Content += "%T " + this.getPaperTitle() + "\r\n";
            Content += "%D " + paper.year + "\r\n";
        }
    }
    if (bibType === "RIS")
    {
        fileName = ".ris";
        if(paper.document_type === 3){
          Content="\r\n\r\nTY  - RESEARCH\r\n";
          Content += "AU  - ";
          let index = 0;
          paper.Authors.forEach(_au=>{
              if (index > 0) Content += "\r\nAU  - ";
              index++;
              Content += _au.lname + ", " + _au.fname;
          });
          Content += "\r\n";
          Content += "T1  - " + this.getPaperTitle() + "\r\n";
          if (paper.document_sub_type === 1 && !this.isNull(paper.LegalPerson))
          {
              Content += "T2  - " + paper.LegalPerson.name +"\r\n";
              Content += "PB  - \r\n";
              Content += "CY  - " + paper.LegalPerson.City.persianCityName + "\r\n";
          }
          Content += "PY  - " + paper.year + "\r\n";
          Content += "L1  - https://civilica.com/doc/" + paper.id + "\r\n";
          Content += "L1  - ";
        }
        if(paper.document_sub_type === 1){
            Content="\r\n\r\nTY  - CPAPER\r\n";
            Content += "AU  - ";
            let index = 0;
            paper.Authors.forEach(_au=>{
                if (index > 0) Content += "\r\nAU  - ";
                index++;
                Content += _au.lname + ", " + _au.fname;
            });
            Content += "\r\n";
            Content += "T1  - " + this.getPaperTitle() + "\r\n";
            if (paper.document_sub_type === 1 && !this.isNull(paper.LegalPerson))
            {
                Content += "T2  - " + paper.LegalPerson.name +"\r\n";
                Content += "PB  - \r\n";
                Content += "CY  - " + paper.LegalPerson.City.persianCityName + "\r\n";
            }
            Content += "PY  - " + paper.year + "\r\n";
            Content += "L1  - https://civilica.com/doc/" + paper.id + "\r\n";
            Content += "L1  - ";
        }
        if(paper.document_sub_type === 2){
            Content="\r\n\r\nTY  - JOUR\r\n";
            Content += "AU  - ";
            let index = 0;
            paper.Authors.forEach(_au=>{
                if (index > 0) Content += "\r\nAU  - ";
                index++;
                Content += _au.lname + ", " + _au.fname;
            });
            Content +="\r\n";
            Content += "T1  - " + this.getPaperTitle() + "\r\n";
            Content += "PY  - " + paper.year + "\r\n";
            Content += "ER  - ";
        }
    }
    if (bibType === "ISI")
    {
        fileName = ".txt";
        if(paper.document_type === 3){
            Content="\r\n\r\nFN ISI Export Format\r\n";
            Content += "VR 1.0\r\n";
            Content += "PT C\r\n";
            Content += "AU ";
            let index = 0;
            paper.Authors.forEach(_au=>{
                if (index > 0) Content += "\r\n   ";
                index++;
                Content += _au.lname + ", " + _au.fname;
            });
            Content += "\r\n";
            Content += "TI " + this.getPaperTitle() + "\r\n";
            if (!this.isNull(paper.LegalPerson))
            {
                Content += "SO " + paper.LegalPerson.name +"\r\n";
                Content += "PU \r\n";
            }
            Content += "PY " + paper.year + "\r\n";
            Content += "UR https://civilica.com/doc/" + paper.id + "\r\n";
            Content += "ER \r\n";
            Content += "EF";
        }
        if(paper.document_sub_type === 1){
            Content="\r\n\r\nFN ISI Export Format\r\n";
            Content += "VR 1.0\r\n";
            Content += "PT C\r\n";
            Content += "AU ";
            let index = 0;
            paper.Authors.forEach(_au=>{
                if (index > 0) Content += "\r\n   ";
                index++;
                Content += _au.lname + ", " + _au.fname;
            });
            Content += "\r\n";
            Content += "TI " + this.getPaperTitle() + "\r\n";
            if (!this.isNull(paper.LegalPerson))
            {
                Content += "SO " + paper.LegalPerson.name +"\r\n";
                Content += "PU \r\n";
            }
            Content += "PY " + paper.year + "\r\n";
            Content += "UR https://civilica.com/doc/" + paper.id + "\r\n";
            Content += "ER \r\n";
            Content += "EF";
        }
        if(paper.document_sub_type === 2){
            Content="\r\n\r\nFN ISI Export Format\r\n";
            Content += "VR 1.0\r\n";
            Content += "PT J\r\n";
            Content += "AU ";
            let index = 0;
            paper.Authors.forEach(_au=>{
                if (index > 0) Content += "\r\n   ";
                index++;
                Content += _au.lname + ", " + _au.fname;
            });
            Content +="\r\n";
            Content += "TI " + this.getPaperTitle() + "\r\n";
            Content += "PY " + paper.year + "\r\n";
            Content += "ER \r\n";
            Content += "EF";
        }
    }
    if (bibType === "Text")
    {
        fileName = ".txt";
        if(paper.document_type === 3){
            Content="";
            let index = 0;
            paper.Authors.forEach(_au=>{
                if (index > 0) Content += " و ";
                index++;
                Content += _au.lname + ", " + _au.fname;
            });
            if (!this.isNull(paper.LegalPerson))
            {
                Content +="," + paper.year + "," + this.getPaperTitle() +"," + paper.LegalPerson.name + "," + paper.LegalPerson.City.persianCityName + ",," + this.getField('Faculty') + ",https://civilica.com/doc/" + paper.id;
            }
            else{
                Content +="," + paper.year + "," + this.getPaperTitle() +",,,,,https://civilica.com/doc/" + paper.id;
            }
        }
        if(paper.document_sub_type === 1){
            Content="";
            let index = 0;
            paper.Authors.forEach(_au=>{
                if (index > 0) Content += " و ";
                index++;
                Content += _au.lname + ", " + _au.fname;
            });
            if (paper.document_sub_type === 1 && !this.isNull(paper.LegalPerson))
            {
                Content +="," + paper.year + "," + this.getPaperTitle() +"," + paper.LegalPerson.name + "," + paper.LegalPerson.City.persianCityName + ",," + this.getField('Faculty') + ",https://civilica.com/doc/" + paper.id;
            }
            else{
                Content +="," + paper.year + "," + this.getPaperTitle() +",,,,,https://civilica.com/doc/" + paper.id;
            }
        }
        if(paper.document_sub_type === 2){
            Content = "";
        }
    }
    if (bibType === "Clipboard")
    {
        fileName = ".txt";
        if(paper.document_type === 3){
          Content="";
          let index = 0;
          paper.Authors.forEach(_au=>{
              if (index > 0) Content += " و ";
              index++;
              Content += _au.lname + ", " + _au.fname;
          });
          if (paper.document_sub_type === 1 && !this.isNull(paper.LegalPerson))
          {
              Content +="," + paper.year + "," + this.getPaperTitle() +"," + paper.LegalPerson.name + "," + paper.LegalPerson.City.persianCityName + ",," + this.getField('Faculty') + ",https://civilica.com/doc/" + paper.id;
          }
          else{
              Content +="," + paper.year + "," + this.getPaperTitle() +",,,,,https://civilica.com/doc/" + paper.id;
          }
          navigator.clipboard.writeText(Content).then(function() {
              this.showToast("کپی محتوا به کلیپرد انجام شد.","success");
          }, function(err) {
              
          });
          return;
      }
        if(paper.document_sub_type === 1){
            Content="";
            let index = 0;
            paper.Authors.forEach(_au=>{
                if (index > 0) Content += " و ";
                index++;
                Content += _au.lname + ", " + _au.fname;
            });
            if (paper.document_sub_type === 1 && !this.isNull(paper.LegalPerson))
            {
                Content +="," + paper.year + "," + this.getPaperTitle() +"," + paper.LegalPerson.name + "," + paper.LegalPerson.City.persianCityName + ",," + this.getField('Faculty') + ",https://civilica.com/doc/" + paper.id;
            }
            else{
                Content +="," + paper.year + "," + this.getPaperTitle() +",,,,,https://civilica.com/doc/" + paper.id;
            }
            navigator.clipboard.writeText(Content).then(function() {
                this.showToast("کپی محتوا به کلیپرد انجام شد.","success");
            }, function(err) {
                
            });
            return;
        }
        if(paper.document_sub_type === 2){
            Content = "";
            return;
        }
    }

    this.downloadExportContent("Citation_" + paper.coi + fileName,Content);
  }
  renderBreadCrumb(){
    var DHL = this.state.dataHolder;
    if (DHL.record.document_sub_type === 1){
      
      if (this.isNull(DHL.record.LegalPerson)) return null;
      return [
        <script type="application/ld+json" dangerouslySetInnerHTML={{__html: `
          {
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
          {
          "@type": "ListItem",
          "position": 1,
          "item": "https://civilica.com",
          "name": "خانه"
          },
          {
          "@type": "ListItem",
          "position": 2,
          "item": "https://civilica.com/search/paper/",
          "name": "مقاله"
          },
          {
          "@type": "ListItem",
          "position": 3,
          "item": "https://civilica.com/l/` + DHL.record.legal_person_id + `/",
          "name": "` + this.pureStringToGoogle(DHL.record.LegalPerson.name) + `"
          },
          {
          "@type": "ListItem",
          "position": 4,
          "item": "https://civilica.com/doc/` + DHL.record.id + `/",
          "name": "` + this.pureStringToGoogle(this.getPaperTitle()) + `"
          }
          ]
          }
          `}} />
        ,
          <ul className='three_dots text-xs container hidden md:flex flex flex-row w-full mt-2 mx-auto border-b border-dashed pb-2 mb-4'>
            <li>
            <NavLink to="/search/paper/" title={DHL.lang === 'en' ? "Download papers" : 'دانلود مقاله'}>{DHL.lang === 'en' ? "Papers" : "مقاله"}</NavLink>
            </li>
            <li className="mx-1">{' > '}</li>
            <li>
            <NavLink to={"/l/" + DHL.record.legal_person_id + "/"} title={this.T(DHL.record.LegalPerson,'legal_person_name')}>{this.T(DHL.record.LegalPerson,'legal_person_name')}</NavLink>
            </li>
            <li className="mx-1">{' > '}</li>
            <li>
            <NavLink to={"/doc/" + DHL.record.id + "/"} title={this.getPaperTitle()}>{this.getPaperTitle()}</NavLink>
            </li>
          </ul>
      ];
    }
    if (DHL.record.document_sub_type === 2){
      
      if (this.isNull(DHL.record.LegalPerson)) return null;
      return [
        <script type="application/ld+json" dangerouslySetInnerHTML={{__html: `
          {
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
          {
          "@type": "ListItem",
          "position": 1,
          "item": "https://civilica.com",
          "name": "خانه"
          },
          {
          "@type": "ListItem",
          "position": 2,
          "item": "https://civilica.com/journals/",
          "name": "مجموعه مقالات ژورنالی"
          },
          {
          "@type": "ListItem",
          "position": 3,
          "item": "https://civilica.com/l/` + DHL.record.LegalPerson.Parent.person_id + `/",
          "name": "` + this.pureStringToGoogle(DHL.record.LegalPerson.Parent.name) + `"
          },
          {
          "@type": "ListItem",
          "position": 4,
          "item": "https://civilica.com/l/` + DHL.record.legal_person_id + `/",
          "name": " دوره ` + DHL.record.LegalPerson.volume + `, شماره ` + DHL.record.LegalPerson.issue + `"
          },
          {
          "@type": "ListItem",
          "position": 5,
          "item": "https://civilica.com/doc/` + DHL.record.id + `/",
          "name": "` + this.pureStringToGoogle(this.getPaperTitle()) + `"
          }
          ]
          }
          `}} />
        ,
          <ul className='three_dots text-xs container hidden md:flex flex flex-row w-full mt-2 mx-auto border-b border-dashed pb-2 mb-4'>
            <li>
            <NavLink to="/search/paper/" title={DHL.lang === 'en' ? "Download papers" : 'دانلود مقاله'}>{DHL.lang === 'en' ? "Papers" : "مقاله"}</NavLink>
            </li>
            <li className="mx-1">{' > '}</li>
            <li>
            <NavLink to={"/l/" + DHL.record.LegalPerson.Parent.person_id + "/"} title={this.T(DHL.record.LegalPerson.Parent,'legal_person_name')}>{this.T(DHL.record.LegalPerson.Parent,'legal_person_name')}</NavLink>
            </li>
            <li className="mx-1">{' > '}</li>
            <li>
            <NavLink to={"/l/" + DHL.record.LegalPerson.person_id + "/"} title={DHL.record.LegalPerson.Parent.name + " دوره " + DHL.record.LegalPerson.volume + ", شماره " + DHL.record.LegalPerson.issue}>دوره {DHL.record.LegalPerson.volume}, شماره {DHL.record.LegalPerson.issue}</NavLink>
            </li>
            <li className="mx-1">{' > '}</li>
            <li>
            <NavLink to={"/doc/" + DHL.record.id + "/"} title={this.getPaperTitle()}>{this.getPaperTitle()}</NavLink>
            </li>
          </ul>
      ];
    }
    if (DHL.record.document_sub_type === 3 ||
        DHL.record.document_sub_type === 4 ||
        DHL.record.document_sub_type === 5 ||
        DHL.record.document_sub_type === 6 ||
        DHL.record.document_sub_type === 8){
      
      if (this.isNull(DHL.record.LegalPerson)) return null;

      var link = '';
      var caption = '';
      if (DHL.record.document_sub_type === 3 ){
        link = '/search/paper/c-0-j-0-pl-0-rd-0-r-0/';
        caption = 'کتابها';
      }
      if (DHL.record.document_sub_type === 4 ){
        link = '/search/paper/c-0-j-0-b-0-rd-0-r-0/';
        caption = 'طرح های پژوهشی';
      }
      if (DHL.record.document_sub_type === 5 ){
        link = '/search/paper/c-0-j-0-b-0-pl-0-r-0/';
        caption = 'اسناد پژوهشی';
      }
      if (DHL.record.document_sub_type === 6 ){
        link = '/search/paper/c-0-j-0-b-0-pl-0-rd-0/';
        caption = 'گزارشات';
      }
      if (DHL.record.document_sub_type === 8 ){
        link = '/search/paper/';
        caption = 'پایان نامه';
      }
      return [
        <script type="application/ld+json" dangerouslySetInnerHTML={{__html: `
          {
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
          {
          "@type": "ListItem",
          "position": 1,
          "item": "https://civilica.com",
          "name": "خانه"
          },
          {
          "@type": "ListItem",
          "position": 2,
          "item": "https://civilica.com` + link + `",
          "name": "` + caption + `"
          },
          {
          "@type": "ListItem",
          "position": 3,
          "item": "https://civilica.com/l/` + DHL.record.LegalPerson.person_id + `/",
          "name": "` + this.pureStringToGoogle(DHL.record.LegalPerson.name) + `"
          },
          {
          "@type": "ListItem",
          "position": 4,
          "item": "https://civilica.com/doc/` + DHL.record.id + `/",
          "name": "` + this.pureStringToGoogle(this.getPaperTitle()) + `"
          }
          ]
          }
          `}} />
        ,
          <ul className='three_dots text-xs container hidden md:flex flex flex-row w-full mt-2 mx-auto border-b border-dashed pb-2 mb-4'>
            <li>
            <NavLink to={link} title={caption}>{caption}</NavLink>
            </li>
            <li className="mx-1">{' > '}</li>
            <li>
            <NavLink to={"/l/" + DHL.record.LegalPerson.person_id + "/"} title={this.T(DHL.record.LegalPerson,'legal_person_name')}>{this.T(DHL.record.LegalPerson,'legal_person_name')}</NavLink>
            </li>
            <li className="mx-1">{' > '}</li>
            <li>
            <NavLink to={"/doc/" + DHL.record.id + "/"} title={this.getPaperTitle()}>{this.getPaperTitle()}</NavLink>
            </li>
          </ul>
      ];
    }
    if (DHL.record.document_sub_type === 9 || DHL.record.document_sub_type === 10 || DHL.record.document_sub_type === 11
      || DHL.record.document_sub_type === 12|| DHL.record.document_sub_type === 13|| DHL.record.document_sub_type === 14
      || DHL.record.document_sub_type === 15|| DHL.record.document_sub_type === 16)
    {
      return [
        <script type="application/ld+json" dangerouslySetInnerHTML={{__html: `
          {
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
          {
          "@type": "ListItem",
          "position": 1,
          "item": "https://civilica.com",
          "name": "خانه"
          },
          {
          "@type": "ListItem",
          "position": 2,
          "item": "https://civilica.com/search/paper/",
          "name": "مقاله"
          },
          {
          "@type": "ListItem",
          "position": 3,
          "item": "https://civilica.com/search/paper/",
          "name": "پیش چاپ"
          },
          {
          "@type": "ListItem",
          "position": 4,
          "item": "https://civilica.com/doc/` + DHL.record.id + `/",
          "name": "` + this.pureStringToGoogle(this.getPaperTitle()) + `"
          }
          ]
          }
          `}} />
        ,
          <ul className='three_dots text-xs container hidden md:flex flex flex-row w-full mt-2 mx-auto border-b border-dashed pb-2 mb-4'>
            <li>
            <NavLink to="/search/paper/" title={DHL.lang === 'en' ? "Preprint" : 'مقاله'}>{DHL.lang === 'en' ? "Preprint" : "مقاله"}</NavLink>
            </li>
            <li className="mx-1">{' > '}</li>
            <li>
            {DHL.lang === 'en' ? "Preprint" : "پیش چاپ"}
            </li>
            <li className="mx-1">{' > '}</li>
            <li>
            <NavLink to={"/doc/" + DHL.record.id + "/"} title={this.getPaperTitle()}>{this.getPaperTitle()}</NavLink>
            </li>
          </ul>
      ];
    }
    return [];
  }
  renderToolBar(classNames,forUnique){
    var DHL = this.state.dataHolder;
    return <div className={'bg-white dark:bg-light-600 shadow-me border rounded overflow-hidden p-4 relative ' + classNames}>
              <div className='flex ltr'>

                {DHL.currentPerson !== null ? (
                  DHL.fav === 0 ? 
                    <div title="افزودن به لیست علاقه مندی ها">
                      <button aria-label="افزودن به لبست علاقه مندی ها" onClick={(e) => this.addDocumentToFav()} className={'over:text-red-600 btn'}>
                        {this.getSVGIcon("heart-plus","h-8 w-8 rtl:ml-2 ltr:mr-2")}
                      </button>
                    </div>
                  :
                    <div title="حذف از علاقه مندی">
                      <button aria-label="حذف از علاقه مندی ها" onClick={(e) => this.removeDocumentFromFav()} className={'hover:text-red-600 btn'}>
                        {this.getSVGIcon("heart-plus","h-8 w-8 rtl:ml-2 ltr:mr-2 text-red-600 fill-current")}
                      </button>
                    </div>
                ) : null}
                <div title={DHL.lang === 'fa' ? "اشتراک گذاری" : "Share"}>
                  <button aria-label={DHL.lang === 'fa' ? "اشتراک گذاری" : "Share"} onClick={(e) => this.setIsOpen()} className={'hover:text-red-500 btn'}>
                    {this.getSVGIcon("share","h-8 w-8 rtl:ml-2 ltr:mr-2")}
                  </button>
                </div>
                <div>
                  <a title={DHL.lang === 'fa' ? this.getPaperTitle() : "Print Friendly"} href={'https://civilica.com/doc/' + DHL.record.id + '/certificate/print/'} className="hover:text-red-500 btn">
                    {this.getSVGIcon("print","h-8 w-8 rtl:ml-2 ltr:mr-2")}
                  </a>
                </div>
                <div>
                <NavLink title={DHL.lang === 'fa' ? "گزارش اشکال در " + this.getCaption() : "Report an Error"} to={'/support/doc/' + DHL.record.id + '/'} className={'text-red-500 btn'}>
                  {this.getSVGIcon("warning","h-8 w-8 rtl:ml-2 ltr:mr-2")}
                </NavLink>
                </div>
                {DHL.record.document_status === 3 ?
                  null
                :
                  ((DHL.record.page_no < 5 || DHL.record.document_status === 0 || DHL.record.credit === 0)
                   && this.isNull(DHL.currentPerson)) ?
                    null
                  :
                    this.hasMedia(1) ? [
                      (this.hasMedia(2) || this.hasMedia(8)) ? 
                        <a href={'https://civilica.com/doc/' + DHL.record.id + '/download/' } title={DHL.lang === 'fa' ? 'دانلود فایل ورد ' + this.getCaption() + ' ' + this.getPaperTitle() : "Download the " + this.getCaption()} >
                          {this.getSVGIcon("file-word","h-8 w-8 rtl:ml-2 ltr:mr-2 text-indigo-600 fill-current")}
                        </a>
                      : null
                    ,
                      <a href={'https://civilica.com/doc/' + DHL.record.id + '/download/' } title={DHL.lang === 'fa' ? 'دانلود فایل پی دی اف ' + this.getCaption() + ' ' + this.getPaperTitle() : "Download the " + this.getCaption()}>
                        {this.getSVGIcon("file-pdf","h-8 w-8 rtl:ml-2 ltr:mr-2 text-red-600 fill-current")}
                      </a>
                    ]
                    :null
                }
              </div>
              <ul className={'space-y-3'}>
                {((DHL.record.document_type === 1 || DHL.record.document_type === 4) && (DHL.record.document_sub_type !== 11 &&
                  DHL.record.document_sub_type !== 13 && DHL.record.document_sub_type !== 14 && DHL.record.document_sub_type !== 12 &&
                  DHL.record.document_sub_type !== 15 && DHL.record.document_sub_type !== 16
                ))
                  ? 
                    <li>
                      <a
                        href={'https://civilica.com/certificate/request/' + DHL.record.id + '/'}
                        title={DHL.lang === 'fa' ? 'صدور گواهی نمایه سازی' : 'Certificate'}
                        className={'flex items-center rounded font-bold text-lime-700 hover:text-lime-700 btn  my-3'}
                      >
                        <svg className="h-6 w-6 rtl:ml-2 ltr:mr-2" viewBox="0 0 512 512">
                        <path d="M247.4 338.3c7.5-7.5 10.37-18.5 7.625-28.75c-5.375-20.62-5.5-17.75 0-38.38c2.748-10.38-.125-21.38-7.625-28.88C232.5 227.1 233.1 229.6 228.5 209C225.9 198.8 217.1 190.8 207.9 188C187.5 182.4 190 183.9 175.1 168.8C167.8 161.3 156.1 158.3 146.9 161c-20.37 5.5-17.49 5.5-37.74 0C99.01 158.3 88.26 161.3 80.89 168.8C65.89 183.9 68.39 182.4 48.14 188C38.02 190.8 30.23 198.8 27.48 209c-5.375 20.75-4 18.12-18.87 33.25c-7.375 7.5-10.33 18.5-7.582 28.88c5.375 20.62 5.375 17.75 0 38.38c-2.75 10.25 .207 21.25 7.582 28.75c14.87 15.12 13.5 12.62 18.87 33.25c2.75 10.38 10.54 18.38 20.67 21.12c14.37 3.875 11.5 3 15.87 5V512l63.99-32l63.99 32v-114.4c4.25-2 1.499-1.125 15.87-5c9.998-2.75 17.1-10.75 20.62-21.12C233.1 350.8 232.5 353.4 247.4 338.3zM128 352c-35.37 0-63.99-28.62-63.99-64S92.64 224 128 224s63.99 28.62 63.99 64S163.4 352 128 352zM493.3 93.38l-74.63-74.64C406.6 6.742 390.3 0 373.4 0L191.1-.0001c-35.35 0-64 28.65-64 64l.0105 68.94c0 0 22.02-10.7 48-.7539L176 64.13c0-8.836 7.164-16 16-16h160L352 128c0 17.67 14.33 32 32 32h79.1v288c0 8.836-7.164 16-16 16H224L223.1 512l224-.0001c35.2 0 64-28.8 64-64V138.6C512 121.7 505.3 105.4 493.3 93.38z" fill="currentColor" />
                        </svg>
                        {DHL.lang === 'fa' ? 'صدور گواهی نمایه سازی' : 'Certificate'}
                      </a>
                    </li>
                  : null}
                <li>
                {DHL.currentPerson !== null ?
                  <span onClick={e=>this.checkPersonToDocAssign()} className={'hand flex items-center rounded font-bold text-lime-700 hover:text-lime-700 btn  my-3'}>
                    {this.getSVGIcon("edit","h-6 w-6 rtl:ml-2 ltr:mr-2")}
                    {DHL.lang === 'fa' ? 'من نویسنده این مقاله هستم' : "I'm the author of the paper"}
                  </span>
                :[
                  <span onClick={e=>this.setState({showClaim:true})} className={'hand flex items-center rounded font-bold text-lime-700 hover:text-lime-700 btn  my-3'}>
                    {this.getSVGIcon("edit","h-6 w-6 rtl:ml-2 ltr:mr-2")}
                    {DHL.lang === 'fa' ? 'من نویسنده این مقاله هستم' : "I'm the author of the paper"}
                  </span>
                ,
                  this.claim()
                ]}
                </li>
              </ul>
              {!this.isEmpty(DHL.subjectKeywords) ?[
                <p className={'mt-4'}>این {this.getCaption()} در بخشهای موضوعی زیر دسته بندی شده است: </p>
              ,
                <ul className='mb-4'>
                    {DHL.subjectKeywords.map(_key=>
                    <li>
                        <NavLink to={"/subject/" + _key.Keyword.Subject.id + "/"} title={"صفحه اختصاصی " + _key.Keyword.Subject.subTitleFa}><b>{_key.Keyword.Subject.subTitleFa}</b></NavLink> &gt; <NavLink to={"/subject/" + _key.Keyword.Subject.id + "/" + _key.Keyword.id + "/"} title={"لیست مقالات " + _key.Keyword.subKeyTitle}><b>{_key.Keyword.subKeyTitle}</b></NavLink>
                    </li>
                    )}
                </ul>
              ]:null}
              <p className={'mt-4'}>
                {DHL.lang === 'fa' ? "استخراج به نرم افزارهای پژوهشی" : "Export"}: 
              </p>
              <div className={'flex items-center justify-center my-3'}>
                <div className={'border border-gray-300 pl-4 flex rounded overflow-hidden dark:border-light-700'}>
                  <select name="bibType" id={"bibType_"+forUnique} className={'border-transparent focus:outline-none focus:ring-0 focus:border-0 cursor-pointer hover:bg-gray-200 dark:bg-light-600  dark:hover:bg-light-700 btn'}>
                    <option>BibTex</option>
                    <option>EndNote</option>
                    <option>RIS</option>
                    <option>ISI</option>
                    <option>Text</option>
                    <option>Clipboard</option>
                  </select>
                  <input className={'pr-2  text-lime-700 hover:text-lime-700 cursor-pointer '} type="submit" value={DHL.lang === 'fa' ? "دانلود" : "GET"} onClick={(e) => this.export(e,forUnique)} />
                </div>{' '}
              </div>
              <span className={'mt-4'}>{this.state.dataHolder.lang === "fa" ? "لینک ثابت به این " : 'Link to this '}{this.getCaption()}: </span>
              <div className='ltr flex flex-wrap'>
                <span className='hand mr-2' title='کپی کردن آدرس' onClick={e=>this.copyToClipBoard('https://civilica.com/doc/' + DHL.record.id + '/')}>
                  {this.getSVGIcon("copy","h-6 w-6 rtl:ml-2 ltr:mr-2")}
                </span>
                <a href={'https://civilica.com/doc/' + DHL.record.id} className={'text-left hover:text-brand dark:hover:text-yellow-500 block text-color-base dark:text-color-base-dark'}>
                  https://civilica.com/doc/{DHL.record.id}
                </a>
              </div>
              {(DHL.record.document_type === 1 || DHL.record.document_type === 4) && [
                <p className='mt-4'>{this.state.dataHolder.lang === "fa" ? "شناسه ملی سند علمی:" : "Document National Code:"}</p>
              ,
                <div className='ltr flex flex-wrap'>
                  <span className='hand mr-2' title='کپی کردن کد یکتا' onClick={e=>this.copyToClipBoard(DHL.record.coi)}>
                    {this.getSVGIcon("copy","h-6 w-6 rtl:ml-2 ltr:mr-2")} 
                  </span>
                  {DHL.record.document_type === 4 ? "pre-"+DHL.record.id : DHL.record.coi}
                </div>
              ]}
              {DHL.record.document_type === 4 && <p className='mt-4'>{this.state.dataHolder.lang === "en" ? "Index date" : "تاریخ نمایه سازی"}: {this.state.dataHolder.lang === "en" ? this.gFormat(DHL.record.add_date) : this.g2j(DHL.record.add_date)}</p>}
              {DHL.record.document_sub_type === 1 && 
                <p className='mt-4'>{this.state.dataHolder.lang === "en" ? "Index date" : "تاریخ نمایه سازی"}: {this.state.dataHolder.lang === "en" ? this.gFormat(DHL.record.add_date) : this.g2j(DHL.record.add_date)}</p>
              }
              {DHL.record.document_sub_type === 2 && 
                <p className='mt-4'>{this.state.dataHolder.lang === "en" ? "Index date" : "تاریخ نمایه سازی"}: {this.state.dataHolder.lang === "en" ? this.gFormat(DHL.record.add_date) : this.g2j(DHL.record.add_date)}</p>
              }
            </div>
  }
  renderAutoText(){
    try{
      if (this.state.template !== 1) return null;

      var DHL = this.state.dataHolder;
      if (DHL.record.language !== 1) return null;

      if (DHL.record.document_sub_type !== 1 && DHL.record.document_type !== 4) return null;

      var legalPersonName = '';
      if (!this.isNull(DHL.record.LegalPerson)){
        legalPersonName = DHL.record.LegalPerson.name;
      }
      var authors = "";
      DHL.record.Authors.sort((a, b) => a.order - b.order).map((_au) => {
        if (!this.isBlank(authors)) authors += "؛ ";
        authors += (_au.fname + ' ' + _au.lname + (!this.isBlank(_au.aff) ? "، " + _au.aff : ""));
      });

      var abstract = "";
      this.getPaperAbstract().split(" ").forEach((a,index)=>{
        if (index<60) abstract += a + " ";
      });
      abstract += "... .";

      var subjects = "";
      DHL.subjectKeywords.forEach(_key=>{
        if (!this.isBlank(subjects)) subjects += " و ";
        subjects += _key.Keyword.subKeyTitle;
      });
      if (!this.isBlank(subjects)) subjects = " این مقاله در دسته بندی موضوعی " + subjects + " طبقه بندی شده است.";

      var downloadText = "";
      if(this.hasMedia(1))
        downloadText = " برای دانلود فایل کامل مقاله " + this.getPaperTitle() + " با "  + DHL.record.page_no + ` صفحه به فرمت PDF، میتوانید از طریق بخش "دانلود فایل کامل" اقدام نمایید.`;

      if (DHL.record.document_type === 4){
        return <blockquote cite={"https://civilica.com/doc/" + DHL.record.id + "/"} className="container mx-auto mb-8 bg-white dark:bg-light-600 shadow-me border rounded overflow-hidden p-4" style={{"border-right": "3px solid #ccc"}}>
        <p>مقاله فارسی "<b>{this.getPaperTitle()}</b>" توسط {authors} نوشته شده  و در تاریخ {this.g2j(DHL.record.add_date,0)} به صورت پیش چاپ در پایگاه سیویلیکا ثبت شده است. کلمات کلیدی استفاده شده در این مقاله {this.getPaperKeywords()} هستند. در چکیده این مقاله اشاره شده است که {abstract}{downloadText}</p>
      </blockquote>
       
      }
      
      return <blockquote cite={"https://civilica.com/doc/" + DHL.record.id + "/"} className="container mx-auto mb-8 bg-white dark:bg-light-600 shadow-me border rounded overflow-hidden p-4" style={{"border-right": "3px solid #ccc"}}>
        <p>مقاله فارسی "<b>{this.getPaperTitle()}</b>" توسط {authors} نوشته شده و در سال {DHL.record.year} پس از تایید کمیته علمی <b>{legalPersonName}</b> پذیرفته شده است. کلمات کلیدی استفاده شده در این مقاله {this.getPaperKeywords()} هستند. این مقاله در تاریخ {this.g2j(DHL.record.add_date)} توسط سیویلیکا نمایه سازی و منتشر شده است و تاکنون {DHL.record.visit} بار صفحه این مقاله مشاهده شده است. در چکیده این مقاله اشاره شده است که {abstract}{subjects}{downloadText}</p>
      </blockquote>

    }
    catch(err){ console.log(err.message); return null}
  }
  render() {
    var DHL = this.state.dataHolder;
    if (!this.isBlank(this.state.redirectTo)) return this.redirectTo();

    if (typeof window !== 'undefined') {
      if (document != undefined && document != null) {
        try {
          document.addEventListener('scroll', () => {
            let scroll = window.scrollY;
            var element = document.getElementById('buy_button');

            if (element) {
              if (scroll > 330) {
                element.classList.add('scrolled');
                element.classList.remove('lg:relative');
                element.classList.remove('lg:border-t-0');
              } else {
                element.classList.remove('scrolled');
                element.classList.add('lg:relative');
                element.classList.add('lg:border-t-0');
              }
            }
          });
        } catch (err) {}
      }
    }

    var html = [this.renderToast()];

    if (this.isNull(DHL)) {
      html.push(this.renderPlaceHolder());
    } else {
      if (DHL.status === 0) {
        html.push(this.renderErorrInLoading());
      }
      if (DHL.status === 404) {
        html.push(this.render404());
      }
      if (DHL.status === 500) {
        html.push(this.render500());
      }
      if (DHL.status === 1) {
        html.push(this.renderHeader());
        html.push(this.setMetaTags());
        html.push(
          <div>
            {this.state.template === 1 && this.renderGoogleStructorsData()}
            {this.state.template === 1 && this.renderBreadCrumb()}
            <section className={"p-2 md:p-0 grid grid-cols-12 gap-4 container mx-auto mb-8 " + (this.state.template === 1 ? "" : "mt-8")}>
              <article className="col-span-12 lg:col-span-7 xl:col-span-8 mb-4">
                {this.renderDocumentDetailItems()}
                {this.state.template === 1 && this.renderToolBar('md:hidden',1)}
                {this.state.template === 1 && this.renderVIPMediaBox()}                
                {this.renderDaneshinAds(15,"mb-4 h90")}
                {this.renderAbstract()}
                
                {this.state.template === 1 && this.renderPreface()}
                {this.state.template === 1 && this.renderToc()}
                {this.renderKeywords()}
                {this.state.template === 1 && !this.isEmpty(DHL.record.Authors) ? <div className="p-4 bg-white shadow-me border rounded dark:bg-light-600 mb-4">{this.renderAuthors()}</div> : null}

                {this.state.template === 1 && this.renderBackground()}
                {this.state.template === 1 && this.renderMethods()}
                {this.state.template === 1 && this.renderResults()}
                {this.state.template === 1 && this.renderDiscussion()}
                {this.state.template === 1 && this.renderConclusions()}
                {this.state.template === 1 && this.renderFigures()}

                {this.state.template === 1 && !this.isEmpty(DHL.refrences) ? (
                  <div className="p-4 bg-white shadow-me border rounded dark:bg-light-600 mb-4">
                    <div className={' mt-4 leading-6 '}>{this.renderRefrences()}</div>
                  </div>
                ) : null}
              </article>
              <aside className="col-span-12 lg:col-span-5 xl:col-span-4">
                <div className="fixed inset-0 bg-gray-500/50 dark:bg-light-500/50 hidden z-99" id="bg_share_modal"></div>
                {this.state.template === 1 ?
                  <div className={' space-y-4'}>
                    {!this.isNull(DHL.currentManager) &&
                      <div className={'bg-white dark:bg-light-600 shadow-me border rounded overflow-hidden p-4'}>
                        <p className={'font-bold h_title mb-2 border-b pb-2 mb-2 border-b pb-2'}>{DHL.lang === 'fa' ? ('بخش مدیریت ' + this.getCaption()) : this.getCaption() + ' Managment'}</p>
                        <div>
                          <div className='mb-2 flex bspace'><span className='font-bold'>دانلودها: </span>{DHL.record.download_count} {this.getEditLink(DHL.record,"paper_requests")}</div>
                          <div className='mb-2 flex bspace'><span className='font-bold'>نظرات: </span>{DHL.record.comment_count} {this.getEditLink(DHL.record,"paper_comments")}</div>
                          <div className='mb-2 flex bspace'><span className='font-bold'>گواهی ها: </span>{DHL.certificate_count} {this.getEditLink(DHL.record,"doc_certificates")}</div>
                          {this.state.dataHolder.medias.map(media=>
                            <div className='mb-2 flex bspace'>
                              <span className='font-bold'>رکوردهای آنلاین فایل {this.mediaFormatName(media.format)}</span>
                              <a href={"/managment/onlinerecords/?mi=" + media.id} target="_blank">
                                <svg className="h-4 w-4" viewBox="0 0 448 512"><path d="M507.3 484.7l-141.5-141.5C397 306.8 415.1 259.7 415.1 208c0-114.9-93.13-208-208-208S-.0002 93.13-.0002 208S93.12 416 207.1 416c51.68 0 98.85-18.96 135.2-50.15l141.5 141.5C487.8 510.4 491.9 512 496 512s8.188-1.562 11.31-4.688C513.6 501.1 513.6 490.9 507.3 484.7zM208 384C110.1 384 32 305 32 208S110.1 32 208 32S384 110.1 384 208S305 384 208 384z"/></svg>
                              </a>
                            </div>
                          )}
                          <div className='mb-2'><NavLink to={"/doc/media/send/" + DHL.record.id + "/"}>ارسال مستقیم {this.getCaption()}</NavLink></div>
                          {DHL.record.document_status == 2 && <div className='mb-2 font-bold text-red-600'>کلیه اطلاعات این {this.getCaption()} از سایت حذف شده است.</div>}
                          {DHL.record.document_status == 3 && <div  className='mb-2 font-bold text-red-600'>فایل اصل این {this.getCaption()} توسط مدیریت حذف شده است.</div>}
                        </div>
                      </div>
                    }
                    {this.state.template === 1 && this.renderToolBar('hidden md:block',2)}
                    {this.state.template === 1 ?
                      !this.isNull(DHL.downloadHistory) ?
                       !this.isBlank(DHL.downloadHistory.hash) &&
                        <div className={'bg-white dark:bg-light-600 shadow-me border rounded overflow-hidden p-4'}>
                          <p className={'font-bold h_title mb-2 border-b pb-2 mb-2 border-b pb-2'}>ثبت نظر و امتیاز شما</p>
                          <DocumentComment hash={DHL.downloadHistory.hash} request_id={DHL.downloadHistory.request[0].id} inline={1} />
                        </div>
                      :null
                    :null}
                    {this.state.template === 1 && this.renderRatingBox()}
                    {this.state.template === 1 && this.renderReviews()}
                    {this.state.template === 1 && this.renderHowToRefrence()}
                    {DHL.refrencedPaper.length > 0 ?
                      <div className={'bg-white dark:bg-light-600 shadow-me border rounded overflow-hidden p-4'}>
                        <p className={'font-bold h_title mb-2 border-b pb-2 mb-2 border-b pb-2'}>{DHL.lang === 'fa' ? 'کدام مقالات به این منبع استناد نموده اند' : 'Citation'}</p>
                        <div>
                            <ul className='flex flex-col divide-y dark:divide-light-700'>
                                {DHL.refrencedPaper.map(_p =>
                                  <li className={(_p.Document.language === 1 || _p.Document.language === 3 ?  "text-right" : "text-left") + ' py-3 hover:bg-gray-50 dark:hover:bg-light-600'} dir={_p.Document.language === 1 || _p.Document.language === 3 ?  "rtl" : "ltr"}>
                                    <NavLink to={"/doc/" + _p.Document.id + "/"} title={_p.Document.title}>{_p.Document.title}</NavLink> 
                                    {_p.Document.year !== "" && _p.Document.year !== null ? "("+_p.Document.year + ")" : null}
                                  </li>
                                )}
                            </ul>
                            <p>بر اساس سیستم تحلیلی استنادات مقالات، تاکنون برای نگارش {DHL.refrencedPaper.length} {this.getCaption()} استفاده شده است.</p>
                        </div>
                      </div>
                    :null}
                    {DHL.record.Authors.sort((a, b) => a.order - b.order).map((_au) =>
                      _au.order === 1 && !this.isNull(_au.Affilation) &&
                        <div className={'bg-white dark:bg-light-600 shadow-me border rounded overflow-hidden p-4'}>
                          {DHL.lang === 'fa' ? <p className={'font-bold h_title mb-2 border-b pb-2 mb-2 border-b pb-2'}>علم سنجی و رتبه بندی {this.getCaption()}</p> : <p className={'font-bold h_title mb-2 border-b pb-2 mb-2 border-b pb-2'}>Scientometrics</p>}
                          <div>
                            <div style={{"background-image": "url('" + this.toImageUrl(_au.Affilation, 'legal_person') + "')","background-repeat": "no-repeat","background-size": "70px","padding-left": DHL.lang === 'fa' ? "70px" : "0","padding-right": DHL.lang === 'fa' ? "0" : "70px","background-position": (DHL.lang === 'fa' ? "left" : "right")}}>
                              {DHL.lang === 'fa'
                                ? 'مشخصات مرکز تولید کننده این ' + this.getCaption() + ' به صورت زیر است:'
                                : 'The specifications of the publisher center of this ' + this.getCaption() + ' are as follows:'}
                              <div>
                                <div>
                                  {this.LinkRenders({
                                    url: this.getLegalLink(_au.Affilation),
                                    title:
                                      (DHL.lang === 'fa' ? 'رتبه علمی ' : 'Ranking of ') +
                                      this.T(_au.Affilation, 'legal_person_name') +
                                      (DHL.lang === 'fa' ? ' در علم سنجی' : ' in Scientometrics'),
                                    content: <b>{(DHL.lang === 'fa' ? 'رتبه علمی ' : 'Ranking of ') + this.T(_au.Affilation, 'legal_person_name')}</b>,
                                  })}
                                </div>
                                {_au.Affilation.role_id === 1 && (
                                  <div>
                                    {DHL.lang === 'fa' ? 'نوع مرکز: ' : 'Type of center: '}
                                    <b>{this.enumString(_au.Affilation.aff_type, 'aff_type')}</b>
                                  </div>
                                )}
                                {_au.Affilation.role_id === 2 && (
                                  <div>
                                    {DHL.lang === 'fa' ? 'نوع مرکز: ' : 'Type of center: '}
                                    <b>ََ{DHL.lang === 'fa' ? 'انجمن' : 'Association'}</b>
                                  </div>
                                )}
                                {_au.Affilation.role_id === 3 && (
                                  <div>
                                    {DHL.lang === 'fa' ? 'نوع مرکز: ' : 'Type of center: '}
                                    <b>{DHL.lang === 'fa' ? 'بانک' : 'Bank'}</b>
                                  </div>
                                )}
                                {_au.Affilation.role_id === 4 && (
                                  <div>
                                    {DHL.lang === 'fa' ? 'نوع مرکز: ' : 'Type of center: '}
                                    <b>{DHL.lang === 'fa' ? 'بیمه' : 'Insurance'}</b>
                                  </div>
                                )}
                                {_au.Affilation.role_id === 5 && (
                                  <div>
                                    {DHL.lang === 'fa' ? 'نوع مرکز: ' : 'Type of center: '}
                                    <b>{DHL.lang === 'fa' ? 'شرکت' : 'Company'}</b>
                                  </div>
                                )}
                                {_au.Affilation.role_id === 58 && (
                                  <div>
                                    {DHL.lang === 'fa' ? 'نوع مرکز: ' : 'Type of center: '}
                                    <b>{DHL.lang === 'fa' ? 'شهرداری' : 'Municipality'}</b>
                                  </div>
                                )}
                                {!this.isEmpty(_au.Affilation.ScienceStats) ? (
                                  <div>
                                    {DHL.lang === 'fa' ? 'تعداد مقالات: ' : 'Paper count: '}
                                    <b>{this.money(_au.Affilation.ScienceStats[0].conf_doc_count + _au.Affilation.ScienceStats[0].journal_doc_count)}</b>
                                  </div>
                                ) : null}
                              </div>
                            </div>

                            {DHL.lang === 'fa' ? (
                              <div className="text-yellow-700">
                                در بخش
                                <b>
                                  <NavLink to="/scientometrics/" title="رتبه بندی دانشگاههای ایران">
                                    {' '}
                                    علم سنجی پایگاه سیویلیکا{' '}
                                  </NavLink>
                                </b>
                                می توانید رتبه بندی علمی مراکز دانشگاهی و پژوهشی کشور را بر اساس آمار مقالات نمایه شده مشاهده نمایید.
                              </div>
                            ) : (
                              <div>
                                In the scientometrics section of CIVILICA, you can see the scientific ranking of the Iranian academic and research centers based on the statistics of indexed
                                articles.
                              </div>
                            )}
                          </div>
                        </div>
                    )}
                    {(DHL.record.document_sub_type === 11 || DHL.record.document_sub_type === 12 || 
                      DHL.record.document_sub_type === 13 || DHL.record.document_sub_type === 14 || 
                      DHL.record.document_sub_type === 15 || DHL.record.document_sub_type === 16) &&
                      <div className={'bg-white dark:bg-light-600 shadow-me border rounded overflow-hidden p-4'}>
                        <p className={'font-bold h_title mb-2 border-b pb-2 mb-2 border-b pb-2'}>دانشگاه</p>
                        <div className='px-4 flex space-x-4 rtl:space-x-reverse items-center py-2 hover:bg-gray-200 dark:hover:bg-light-500 '>
                          <div className='flex-shrink-0'>
                            <div className="rounded-full w-12 h-12 image48" style={{"background-image": "url('" + this.toImageUrl(DHL.record.LegalPerson, 'legal_person') + "')"}}></div>
                          </div>
                          <div className='flex flex-col'>
                            <NavLink to={'/l/' + DHL.record.legal_person_id + '/'} title={this.T(DHL.record.LegalPerson, 'legal_person_name')} className="font-bold">
                              {this.T(DHL.record.LegalPerson, 'legal_person_name')}
                            </NavLink>
                          </div>
                        </div>
                      </div>
                    }
                    {DHL.record.document_type === 3 &&
                      <div className={'bg-white dark:bg-light-600 shadow-me border rounded overflow-hidden p-4'}>
                        <p className={'font-bold h_title mb-2 border-b pb-2 mb-2 border-b pb-2'}>صاحب اثر</p>
                        <div className='px-4 flex space-x-4 rtl:space-x-reverse items-center py-2 hover:bg-gray-200 dark:hover:bg-light-500 '>
                          <div className='flex-shrink-0'>
                            <div className="rounded-full w-12 h-12 image48" style={{"background-image": "url('" + this.toImageUrl(DHL.record.LegalPerson, 'legal_person') + "')"}}></div>
                          </div>
                          <div className='flex flex-col'>
                            <NavLink to={'/l/' + DHL.record.legal_person_id + '/'} title={this.T(DHL.record.LegalPerson, 'legal_person_name')} className="font-bold">
                              {this.T(DHL.record.LegalPerson, 'legal_person_name')}
                            </NavLink>
                            <NavLink className="text-yellow-700 font-bold" to={"/search/paper/l-" + DHL.record.legal_person_id + "-ft-0/"} title="لیست همه طرح های این مرکز">لیست همه طرح های این مرکز</NavLink>
                          </div>
                        </div>
                      </div>
                    }
                    {DHL.record.document_type === 3 &&
                      <div className={'bg-white dark:bg-light-600 shadow-me border rounded overflow-hidden p-4'}>
                        <p className={'font-bold h_title mb-2 border-b pb-2 mb-2 border-b pb-2'}>مجری</p>
                        <div className='px-4 flex space-x-4 rtl:space-x-reverse items-center py-2 hover:bg-gray-200 dark:hover:bg-light-500 '>
                          <div className='flex-shrink-0'>
                            <div className="rounded-full w-12 h-12 image48" style={{"background-image": "url('" + this.toImageUrl(DHL.record.LegalPerson2, 'legal_person') + "')"}}></div>
                          </div>
                          <div className='flex flex-col'>
                            <NavLink to={'/l/' + DHL.record.legal_person_id2 + '/'} title={this.T(DHL.record.LegalPerson2, 'legal_person_name')} className="font-bold">
                              {this.T(DHL.record.LegalPerson2, 'legal_person_name')}
                            </NavLink>
                          </div>
                        </div>
                      </div>
                    }
                    {!this.isEmpty(DHL.recomentions) ? (
                      <div className="bg-white dark:bg-light-600 shadow-me border rounded overflow-hidden p-4">
                        <p className="font-bold h_title mb-2 border-b pb-2 mb-2 border-b pb-2">مقالات پیشنهادی مرتبط</p>
                          <ul className="flex flex-col space-y-4 mt-4">
                          {DHL.recomentions.map((item, index) =>
                            <li key={index} className="flex">
                              {this.getEditLink(item, 'paper')}
                              <NavLink to={'/doc/' + item.to_document_id + '/'} title={item.ToDocument.title}>{item.ToDocument.title}</NavLink>
                            </li>
                          )}
                        </ul>
                        <p>مقالات فوق بر اساس داده کاوی مقالات مطالعه شده توسط پژوهشگران محاسبه شده است.</p>
                      </div>
                    ) : null}
                    {!this.isEmpty(DHL.related_paper) ? (
                      <div className="bg-white dark:bg-light-600 shadow-me border rounded overflow-hidden p-4">
                        <p className="font-bold h_title mb-2 border-b pb-2 mb-2 border-b pb-2">{this.state.dataHolder.lang === "en" ? "Related papers" : "مقالات مرتبط جدید"}</p>
                        <ul className="flex flex-col space-y-4 mt-4">
                          {DHL.related_paper.map((item, index) => (
                            <li key={index} className="flex">
                              {this.getEditLink(item, 'paper')}
                              <NavLink to={'/doc/' + item.id + '/'} title={item.title}>{item.title}</NavLink>
                            </li>
                          ))}
                        </ul>
                      </div>
                    ) : null}
                    {!this.isEmpty(DHL.related_research) ? (
                      <div className="bg-white dark:bg-light-600 shadow-me border rounded overflow-hidden p-4">
                        <p className="font-bold h_title mb-2 border-b pb-2 mb-2 border-b pb-2">{this.state.dataHolder.lang === "en" ? "Related researches" : "طرح های پژوهشی مرتبط جدید"}</p>
                        <ul className="flex flex-col space-y-4 mt-4">
                          {DHL.related_research.map((item, index) =>
                            <li key={index} className="flex">
                              {this.getEditLink(item, 'paper')}
                              <NavLink to={'/doc/' + item.id + '/'} title={item.title}>{item.title}</NavLink>
                            </li>
                          )}
                        </ul>
                      </div>
                    ) : null}
                    {!this.isBlank(DHL.record.cover) && <div className="bg-white dark:bg-light-600 shadow-me border rounded overflow-hidden">
                        <p className="font-bold h_title mb-2 border-b pb-2 mb-2 border-b pb-2 p-4">پیش نمایش</p>
                        <a title={this.getPaperTitle()} target='_blank' href={"/media/d/"+DHL.record.cover}><img src={"/media/d/"+DHL.record.cover} alt={this.getPaperTitle()} /></a>
                        </div>}
                    <div
                      id="share_modal"
                      className="fixed hidden -translate-x-1/2 left-1/2 transform -translate-y-1/2 top-1/2 flex-col z-999  border border-gray-200 dark:border-light-600 shadow-me border  p-4 bg-white dark:bg-light-600 sm:w-80 w-full rounded"
                    >
                      <header className="relative">
                        <button aria-label="بستن" onClick={() => this.setIsOpen()} className="absolute top-0 rtl:left-0 ltr:right-0 p-2 rounded-full hover:bg-gray-200 dark:hover:bg-light-700">
                          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                          </svg>
                        </button>
                      </header>
                      {this.getSocialShareLinks()}
                    </div>                  
                  </div>
                :null}
                {this.state.template === 2 ?
                  <div className={' space-y-4'}>
                    {!this.isNull(DHL.currentManager) &&
                      <div className={'bg-white dark:bg-light-600 shadow-me border rounded overflow-hidden p-4 relative'}>
                        <p className={'font-bold h_title mb-2 border-b pb-2 mb-2 border-b pb-2'}>بخش مدیریت مقاله</p>
                        <ul className={'space-y-3'}>
                          <li><NavLink to={"/isi/media/send/" + DHL.record.Paper_ID + "/"}>ارسال مستقیم مقاله</NavLink></li>
                          <li>{DHL.fromLocalDB === false ?
                            "اطلاعات این مقاله از کراس رف دریافت شد"
                            :
                            "اطلاعات این مقاله از سرور سیویلیکا دریافت شد"
                            }
                          </li>
                          <li>
                            {this.isBlank(DHL.record.filename)?
                                "فایل این مقاله موجود نمی باشد"
                            :
                                "نام فایل مقاله: " + DHL.record.filename
                            }
                          </li>
                          {!this.isBlank(DHL.record.filename) &&
                            <li>
                              <a target="_blank" href={'/isi/test-download/' + DHL.record.Paper_ID + '/'} title="دانلود مستقیم فایل مقاله">دانلود مستقیم فایل مقاله</a>
                            </li>
                          }
                          <li>
                            کدمقاله: {DHL.record.Paper_ID}
                          </li>
                        </ul>
                      </div>
                    }
                    <div className={'bg-white dark:bg-light-600 shadow-me border rounded overflow-hidden p-4'}>
                      {DHL.lang === 'fa' ?
                        <p className={'font-bold h_title mb-2 border-b pb-2 mb-2 border-b pb-2'}>راهنمای بخش مقالات بین المللی ISI </p>
                      :
                        <p className={'font-bold h_title mb-2 border-b pb-2 mb-2 border-b pb-2'}>Help</p>
                      }
                      <span>
						            مجموعه سیویلیکا در کنار انتشار مقالات کنفرانسها و ژورنالهای معتبر داخلی، به منظور تامین کلیه نیازهای پژوهشی و تحقیقاتی پژوهشگران، خدمات دانلود مقالات کامل بین المللی ISI را نیز ارائه می نماید.
                        <br />
                        برای دانلود متن کامل مقاله با عنوان {this.getPaperTitle()} که اطلاعات آن نمایش داده می شود، بر اساس نحوه دسترسی شما به مجموعه سیویلیکا می توانید اقدام نمایید. برای کاربران غیر عضو باکس خرید تک مقاله نمایش داده می شود. کاربران عضو از طریق ورود به سایت و مراجعه به این صفحه می توانند اصل مقاله را دانلود نمایند.
                        <br />
                        خواهشمندیم در صورتی که از اطلاعات و شرایط مقاله مورد نظر مطمئن نیستید، ابتدا از طریق «لینک اطلاعات کامل مقاله» به صفحه این مقاله در سایت ژورنال یا ناشر مربوطه مراجعه نموده و اطلاعات کامل را در آن سایت کنترل نمایید.
                        <br />
                      </span>
                    </div>
                    <div
                      id="share_modal"
                      className="fixed hidden -translate-x-1/2 left-1/2 transform -translate-y-1/2 top-1/2 flex-col z-999  border border-gray-200 dark:border-light-600 shadow-me border  p-4 bg-white dark:bg-light-600 sm:w-80 w-full rounded"
                    >
                      <header className="relative">
                        <button aria-label="بستن" onClick={() => this.setIsOpen()} className="absolute top-0 rtl:left-0 ltr:right-0 p-2 rounded-full hover:bg-gray-200 dark:hover:bg-light-700">
                          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                          </svg>
                        </button>
                      </header>
                      {this.getSocialShareLinks()}
                    </div>                  
                  </div>
                :null}
              </aside>
            </section>
            {this.renderAutoText()}
          </div>
        );
        if (this.state.template === 1){
          if (DHL.record.document_type===1){
            if(!this.isBlank(DHL.record.cover)){
              html.push(<a className='hidden' href={"/media/d/"+DHL.record.cover} title={this.getPaperTitle()}>{this.getPaperTitle()}</a>);
            }
          }
        }
        html.push(this.renderFooter());
        this.runLazyLoding();
      }
    }
    return html;
  }
}
var DocumentExp = (props) => <Document {...props} params={useParams()} />;
export default DocumentExp;